/* eslint-disable no-mixed-spaces-and-tabs */
import { Checkbox, DatePicker, Drawer, message, Select, Table, Modal } from "antd";
import { isEmpty, isNull, map, orderBy } from "lodash";
import moment from "moment-timezone";
import React, { Component, useEffect, useLayoutEffect, useState } from "react";
// import Modal from "antd/lib/modal/Modal";
import chevronDown from "../../../../../Assets/images/chevron-down.png";
import Loader from "../../../../Common/Component/Loader";
import CustomMap from "../../../ProposalDetail/Component/Common/CustomMap";
import EditService from "../Common/EditService";
import EditServiceNew from "../Common/EditServiceNew";
import EditWorkOrderNew from "./EditWorkOrderNew";
import PauseService from "../Common/PauseService";
import RequestRepair from "../Common/RequestRepair";
import ViewServiceHistory from "../Common/ViewServiceHistory";
import DataTable from "./DataTable";
import { errorHandle } from "../../../../Common/errorHandle";
import WorkOrderOutsideAlerter from "../../../../Common/workOrderOutsideAlerter";
import close from '../../../../../Assets/images/close.png';
import TechnicianOutsideAlerter from "../../../../Common/technicianOutsideAlerter";
import StatusOutsideAlerter from "../../../../Common/statusOutsideAlerter";
import workOrderStatus from '../../../../Common/workOrderStatus.json';
import ServiceOutsideAlerter from "../../../../Common/serviceOutsideAlerter";
import editIcon from '../../../../../Assets/images/edit-pencil-green.svg';
import addGreenCircle from '../../../../../Assets/images/add-circle-outline-green.svg';
import playIcon from '../../../../../Assets/images/pauseplay-icon.svg';
import pauseIcon from '../../../../../Assets/images/Pause.svg';
import axios from "../../../../../Lib/axios";
import * as yup from "yup";
import { CloseOutlined } from "@ant-design/icons";
import { useRef } from "react";
import chevronRight from '../../../../../Assets/images/chevron-right.png';

const { RangePicker } = DatePicker;
const { Option } = Select;

// Bags maping
let BAGS = {
  header_bags: "Header Bags",
  roll_bags: "Roll Bags",
  dont_know: "Dont Know",
};

// mapping frequency for hardcoded
const FREQUENCY_MAPPING = {
  weekly: "Weekly",
  bi_monthly: "Every Other Week",
  once: "Just Once",
  twice_weekly: "Twice Weekly",
  monthly: "Monthly",
};

// service type mapping
const SERVICE_TYPE_MAPPING = {
  pet_waste_stations: "Pet Waste Stations",
  pet_waste_station_bags: "Pet Waste Station Bags",
  pet_waste_station_service: "Pet Waste Station Service",
  common_area_cleaning: "Common Area Cleaning",
  trash_can_service: "Trash Can Service",
  repair: "Repair",
  other: "Other"
};

// {"count":1,"next":null,"previous":null,"results":[{"uuid":"33c969fe-dc1e-489e-a916-68444f2b08ed","field_office_uuid":"e8613212-b1ea-4061-b06c-4f30f4a4f84a","service_type":"residential","property_type":"townhouse","frequency":"twice_weekly","is_prepaid":false,"prepay_months":null,"pet_count":2,"area_to_clean":["front yard"],"last_cleaned":"less_than_2_weeks","service_address":{"uuid":"d8a7e19d-ccac-4ca1-9d48-7688d5f7d8e3","address":"3502 A Lakeview Pkwy","city":"Rowlett","state":"TX","zip_code":"75088","geo_location":null},"billing_address":{"uuid":"0097a4bb-7f90-4f66-be9f-312ab195c56d","address":"5615 W Fuqua St","city":"Houston","state":"TX","zip_code":"77085","geo_location":{"latitude":34.8221396,"longitude":-82.2953955}},"preferred_start_date":"2021-07-16","is_billing_address_same":false,"first_name":"DemoEsha","last_name":null,"email":"esha11test@gmail.com","preferred_contact_methods":[],"phone_numbers":[{"uuid":"e235c4e4-74b5-46ca-b210-b507d3e03b64","phone":"3453453453","type":"home_phone","can_send_sms":false,"primary":false}],"has_doggy_door":false,"is_dogs_outside":false,"can_clean_if_dogs_out":true,"cleaning_notes":"","disposal_location":"test","pets":[{"uuid":"6b9b337c-980f-49b6-8ea7-040d7505873f","name":"","breed":"","birthday":null,"is_friendly":false,"can_treat":false,"additional_info":"","can_clean_if_in_yard":false,"has_doggy_door":true,"photo":null,"service_order_uuid":"33c969fe-dc1e-489e-a916-68444f2b08ed","service_address":"3502 A Lakeview Pkwy, Rowlett, TX. 75088"},{"uuid":"bd2f555b-cdb7-4897-99bc-400c199783bb","name":"Ace","breed":"Bulldog","birthday":null,"is_friendly":false,"can_treat":false,"additional_info":"","can_clean_if_in_yard":false,"has_doggy_door":true,"photo":null,"service_order_uuid":"33c969fe-dc1e-489e-a916-68444f2b08ed","service_address":"3502 A Lakeview Pkwy, Rowlett, TX. 75088"}],"hear_about_us":[],"stripe_card_details":{"brand":"visa","checks":{"address_line1_check":null,"address_postal_code_check":null,"cvc_check":null},"country":"US","exp_month":2,"exp_year":2022,"funding":"credit","generated_from":null,"last4":"1111","networks":{"available":["visa"],"preferred":null},"three_d_secure_usage":{"supported":true},"wallet":null},"calculated_price":{"coupon":{"savings":0,"description":null,"coupon_applied":null},"frequency":"twice_weekly","pet_count":2,"is_prepaid":false,"price_shown":"twice_weekly","prepay_price":{"six_months":{"coupon":{"savings":0,"description":null,"coupon_applied":null},"savings":72.45,"price_shown":"six_months","services_count":52,"price_after_discount":1376.55,"price_before_prepay_discount":1449.0},"twelve_months":{"coupon":{"savings":0,"description":null,"coupon_applied":null},"savings":285.3,"price_shown":"annual","services_count":104,"price_after_discount":2567.7,"price_before_prepay_discount":2853.0}},"prepay_months":null,"property_type":"townhouse","cleaning_areas":{"items":[{"area":"front yard","price":0}],"total_price":0},"prepay_discount":10,"one_time_charges":{"one_time_items":[{"name":"less_than_2_weeks","type":"last_clean","price":45.0}],"total_one_time_charge":45.0},"recurring_add_ons":{"recurring_addon_items":[],"total_recurring_addon_cost":0},"service_base_price":27.0,"total_price_per_service":27.0,"total_price_for_first_visit":72.0},"coupon_code":"","next_service_date":"2021-07-16T00:00:00Z","next_service_bags":false,"service_unavailable_days":["fri"],"is_enquiry":false,"user_token":null}]}
class Services extends Component {
  state = {
    serviceOrder: {},
    loader: false,
    selectedService: null,
    currentEditselectedService: null,
    selectedView: 0,
    selectedHistory: [],
    historyCount: 0,
    currentHistory: {},
    historyPagination: { showSizeChanger: false, pageSize: 10, ordering: "" },
    unavailableDays: [
      { key: "sun", value: "Sunday", checked: false },
      { key: "mon", value: "Monday", checked: false },
      { key: "tues", value: "Tuesday", checked: false },
      { key: "wed", value: "Wednesday", checked: false },
      { key: "thurs", value: "Thursday", checked: false },
      { key: "fri", value: "Friday", checked: false },
      { key: "sat", value: "Saturday", checked: false },
    ],
    pauseServiceVisible: false,
    viewHistory: false,
    editService: false,
    visible_edit_workOrder: false,
    workorder_uuid: '',
    addOns: [],
    requestRepair: false,
    isUpdateDays: false,
    isUpdateService: false,
    toggleServiceOrderFilter: false,
    serviceOrderFilter: [],
    service_order__uuid: [],
    toggleWorkOrderFilter: false,
    work_order_number: [],
    woSearch: '',
    toggleTechnicianFilter: false,
    FieldTechnician: [],
    technician__uuid: [],
    toggleStatusFilter: false,
    status: [],
    CommercialWorkOrderList: [],
    workOrderFilter: [],
    viewType: 'upcoming',
    ordering: '',
    scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"),
    scheduled_time__lt: null,
    isServiceDetail: false,
    transection_type: 'Create',
    startDate: null,
    endDate: null,
    scheduled_time__range: null,
  };

  getRedirectToService = () => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    
    return params.redirect_to_service;
  }

  getRedirectToWorkOrder = () => {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    
    return params.redirect_to_work_order;
  }

  componentDidMount = () => {
    const { customerId } = this.props;
    
    if(this.getRedirectToService())
    {
      const query = this.props?.history?.location?.state?.query;

      this.setState({
        loader: true,
        selectedView: 3,
      }, () => this.onViewService(query.service));
      this.props.getServiceOrderById(query.service?.uuid);
      this.props.getServiceOrderFilter({service_order__user__uuid: query.id});
      this.props.getWorkOrderFilter({service_order__user__uuid: query.id, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
      this.props.getFieldTechnicianFilter();
      this.props.getCommercialWorkOrderList({service_order__user__uuid: query.id, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
    }
    else if (this.getRedirectToWorkOrder())
    {
      const query = this.props?.history?.location?.state?.query;

      this.setState({
        loader: true,
        showAddons: true,
        transection_type: query.transection_type==="Edit"?"Edit":"View",
        visible_edit_workOrder: true,
        workorder_uuid:query?.work_order_uuid,
        currentRecord: {uuid: this.props?.history?.location?.state?.query.work_order_uuid}
      });
      this.props.getServiceOrder({ user__uuid: query.id })
      this.props.getServiceOrderFilter({service_order__user__uuid: query.id});
      this.props.getWorkOrderFilter({service_order__user__uuid: query.id, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss")});
      this.props.getFieldTechnicianFilter();
      this.props.getCommercialWorkOrderList({service_order__user__uuid: query.id, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
    }
    else
    {
      if (customerId) {
        // getServiceOrder({ user__uuid: customerId }); // get service orders
        this.props.getServiceOrderFilter({ service_order__user__uuid: customerId });
        this.props.getCommercialWorkOrderList({ service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time' });
        this.props.getFieldTechnicianFilter();
        this.props.getWorkOrderFilter({ service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss") });
      }
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { selectedService, unavailableDays, serviceOrder, selectedHistory, isUpdateDays, isUpdateService } = this.state;
    this.setState({ loader: false });
    // when there is a differnce between services and selected service is not null we need to look for the selected service in the new services

    // errors
    if (nextProps?.Service?.errors && Object.keys(nextProps?.Service?.errors).length > 0 && JSON.stringify(nextProps?.Service?.errors) !== JSON.stringify(this.props?.Service?.errors)) {
      this.setState({ loader: false });
      errorHandle(nextProps?.Service?.errors)
    }

    // get service order
    if (Object.keys(nextProps?.ServiceOrder?.data).length > 0
      && JSON.stringify(nextProps?.ServiceOrder?.data) !== JSON.stringify(serviceOrder)) {
      const response = nextProps?.ServiceOrder?.data;
      this.setState({ serviceOrder: response });

      if(!isNull(selectedService))
      {
        const services =  response?.results;
        let updatedServiceIndex = services?.findIndex((item) => item.uuid === selectedService.uuid);
        this.setState({selectedService: services[updatedServiceIndex], currentSelectedService: services[updatedServiceIndex]});
      }
    }

    // get service history
    if (Object.keys(nextProps?.Service?.data).length > 0
      && JSON.stringify(nextProps?.Service?.data?.results) !== JSON.stringify(selectedHistory)) {
      let data = [];
      for (let index = 0; index < nextProps?.Service?.data?.results.length; index++) {
        const element = nextProps?.Service?.data?.results[index];
        element.scheduled_time = element.scheduled_time.replace('Z', '');
        data.push(element)
      }
      this.setState({
        selectedHistory: data,
        historyCount: nextProps?.Service?.data?.count,
      });
    }

    // edit service
    if (Object.keys(nextProps?.Service?.editService).length > 0
      && JSON.stringify(nextProps?.Service?.editService) !== JSON.stringify(this.props?.Service?.editService)) {
      if (isUpdateDays || isUpdateService) {
        message.success('Updated successfully', 10)
      }

      /**
       * AUTHOR: Ritesh Solanki
       * <DP-3687></DP-3687>
       */
      // map(unavailableDays, obj => {
      //   obj.checked = !!nextProps?.Service?.editService?.service_unavailable_days?.includes(obj.key);
      // });
      this.setState({
        selectedService: { ...selectedService, ...nextProps?.Service?.editService },
        // unavailableDays,
        isUpdateDays: false,
        isUpdateService: false
      });
    }

    //set selected service
    if (Object.keys(nextProps?.ServiceOrder?.data || {}).length > 0 && Object.keys(nextProps?.ServiceOrder?.data?.results?.[0] || {}).length > 0) {
      this.setState(() => {
        /**
         * AUTHOR: Ritesh Solanki
         * <DP-3687></DP-3687>
         */
        unavailableDays.forEach((obj) => {
          obj.checked = !!this.state.selectedService?.service_unavailable_days?.includes(obj.key);
        });
        this.setState({ unavailableDays });
      });
    }

    // get add ons
    if (Object.keys(nextProps?.Service?.fieldOffice).length > 0) {
      this.setState({ addOns: nextProps?.Service?.fieldOffice?.add_on });
    }

    // Write this code to fix DOOR-1304
    // get service
    if (Object.keys(nextProps?.Service?.pauseList).length > 0
      && JSON.stringify(nextProps?.Service?.pauseList) !== JSON.stringify(this.state.pauseList)) {
      this.props.viewService({ service_order__uuid: selectedService?.uuid, limit: 10, offset: 0 });
    }

    // delete service
    if (Object.keys(nextProps?.Service?.deletePauseService).length > 0
      && JSON.stringify(nextProps?.Service?.deletePauseService) !== JSON.stringify(this.state.deletePauseService)) {
      this.props.viewService({ service_order__uuid: selectedService?.uuid, limit: 10, offset: 0 });
    }

    //get service order filters
    if (nextProps?.serviceOrderFilter && nextProps?.serviceOrderFilter?.data && nextProps?.serviceOrderFilter?.data?.data && Object.keys(nextProps?.serviceOrderFilter?.data?.data).length > 0) {
      this.setState({ serviceOrderFilter: nextProps?.serviceOrderFilter?.data?.data }, () => {
        // console.warn('serviceOrderFilter', this.state.serviceOrderFilter)
      });
    }

    //get work orders
    if (nextProps?.CommercialWorkOrderList && nextProps?.CommercialWorkOrderList?.data && nextProps?.CommercialWorkOrderList?.data?.results && Object.keys(nextProps?.CommercialWorkOrderList?.data?.results).length > 0) {
      this.setState({ CommercialWorkOrderList: nextProps?.CommercialWorkOrderList?.data?.results, workOrderFilter: nextProps?.workOrderFilter?.data?.data }, () => {
        // console.warn('CommercialWorkOrderList', this.state.CommercialWorkOrderList)
      });
    } else {
      this.setState({ CommercialWorkOrderList: [] }, () => {
        // console.warn('CommercialWorkOrderList', this.state.CommercialWorkOrderList)
      });
    }

    //get work order filters
    // if (nextProps?.workOrderFilter && nextProps?.workOrderFilter?.data && nextProps?.workOrderFilter?.data?.data && Object.keys(nextProps?.workOrderFilter?.data?.data).length > 0 &&
    //   Object.keys(nextProps?.workOrderFilter?.data?.data).length !== this.state.workOrderFilter.length) {
    //   this.setState({ workOrderFilter: nextProps?.workOrderFilter?.data?.data }, () => {
    //     // console.warn('workOrderFilter', this.state.workOrderFilter)
    //   });
    // }
    // else
    // {
    //   this.setState({ workOrderFilter: [] }, () => {
    //     // console.warn('workOrderFilter', this.state.workOrderFilter)
    //   });
    // }
    //get field technician filters
    if (nextProps?.FieldTechnician && nextProps?.FieldTechnician?.technicianList && nextProps?.FieldTechnician?.technicianList?.results && Object.keys(nextProps?.FieldTechnician?.technicianList?.results).length > 0) {
      this.setState({ FieldTechnician: nextProps?.FieldTechnician?.technicianList?.results }, () => {
        // console.warn('FieldTechnician', this.state.FieldTechnician)
      });
    }
  };

  // convert date time from local to utc
  localToUTC = (date) => {
    return moment.utc(date)
  }

  // on change view
  onChangeView = (value, callback) => {
    this.setState({ selectedView: value }, () => callback && callback());
  };

  //Table Server side pagination
  handleTableChange = (pagination) => {
    const { historyPagination, selectedService } = this.state;
    Object.assign(historyPagination, { "current": pagination.current });
    this.setState({
      historyPagination,
      loader: true,
    });

    this.props.viewService({
      offset: (pagination.current * 10) - 10,
      limit: 10,
      service_order__uuid: selectedService?.uuid,
      ordering: historyPagination?.ordering,
    });
  };

  // on change day
  onChangeDay = (e, row) => {
    const { unavailableDays } = this.state;
    Object.assign(unavailableDays[row], { [e.target.name]: !e.target.checked });
    this.setState({ unavailableDays });
  };

  // toggle pause service
  togglePauseService = (value) => {
    this.setState({ pauseServiceVisible: value });
  };

  // toggle edit service
  toggleEditService = (value) => {
    this.setState({ editService: value });
  };

  // toggle edit service
  toggleEditWorkOrder = (value) => {
    this.setState({ visible_edit_workOrder: value });
  };

  // toggle view history
  toggleViewHistory = (value) => {
    this.setState({ viewHistory: value });
  };

  // toggle request repair
  toggleRequestRepair = (value) => {
    this.setState({ requestRepair: value });
  };

  //Service history order
  onServiceHistoryOrder = (e) => {
    let { historyPagination, selectedService } = this.state;

    Object.assign(historyPagination, { "ordering": e, current: 1 });
    this.setState({ historyPagination });
    let data = { service_order__uuid: selectedService?.uuid, ordering: e, limit: 10, offset: 0, is_history: true };

    if (e === "") {
      delete data.ordering;
    }
    this.props.viewService(data);
  };

  // on update unavailable day
  onUpdateDays = () => {
    const { selectedService, unavailableDays } = this.state;
    let service_unavailable_days = [];
    this.setState({ loader: true, isUpdateDays: true });
    map(unavailableDays, (obj => {
      if (obj.checked) service_unavailable_days.push(obj.key);
    }));
    this.props.editService(selectedService?.uuid, {
      service_unavailable_days,
    });
  };

  // on view service click
  onViewService = (item) => {
    const { unavailableDays } = this.state;
    const { customerId } = this.props;
    this.props.viewService({ service_order__uuid: item?.uuid, limit: 10, offset: 0, is_history: true });
    // this.props.getFranchiseById(item?.field_office_uuid)
    map(unavailableDays, obj => {
      if (item?.service_unavailable_days?.includes(obj.key)) {
        obj.checked = true;
      }
    });
    this.props.toggleServiceAgreementButton();
    this.setState({
      selectedService: item, 
      unavailableDays,
      toggleServiceOrderFilter: false,
      toggleWorkOrderFilter: false,
      toggleTechnicianFilter: false,
      toggleStatusFilter: false,
      scheduled_time__range: null,
      service_order__uuid: [],
      work_order_number: [],
      technician__uuid: [],
      status: [],
      currentSelectedService: item
    }, () => this.onChangeView(1));
    this.setState({ unavailableDays }, () =>
      this.onFilterChange(),
    this.onChangeView(1),
    this.clearStatus()
    );
  };

  // render service overview
  renderServiceOverview = (item) => {
    const { isUpdateService } = this.state;
    let _markers = [], multiple_locations = item?.commercial_detail?.multiple_locations, address = item?.service_address;
    if (multiple_locations && multiple_locations !== "None") {
      let locations = multiple_locations?.split("MULTIPOINT")[1];
      locations = locations?.trim().substr(1, locations.trim().length - 2);
      let temp = locations?.split(", ");
      map(temp, (obj) => _markers.push({ lat: obj.split(" ")[0], lng: obj.split(" ")[1] }));
    } else if (!isEmpty(address) && !isEmpty(address?.geo_location)) {
      _markers = [{ lat: address?.geo_location?.latitude, lng: address?.geo_location?.longitude }];
    }
    let total = 0;
    map(item?.commercial_detail?.line_items, x => {
      if (x?.frequency !== "once") {
        const rateTax = parseFloat(x?.rate) * (parseFloat(x?.rate_tax) / 100);
        total += ((parseFloat(x?.quantity) * parseFloat(x?.rate)) + rateTax) - parseFloat(x?.discount);
      }
    });


    return (
      <React.Fragment>
        {
          !isEmpty(_markers) && !isUpdateService ?
            <div className="map">
              <CustomMap markers={_markers} />
            </div> : ""
        }
        {/* <div className="plr-15">
          <div className={'flex'} style={{ alignItems: 'center' }}>
            <span
              className="snum mt-20">{!isEmpty(item?.service_address) ? `${item?.service_address?.state}-${item?.service_address?.zip_code}` : "-"}</span>
            {item?.is_paused ? <span className="status" style={{ color: 'white', backgroundColor: '#08afcd' }}>Paused</span> : ''}
          </div>
          <h5
            className="sadd">{!isEmpty(item?.service_address) ? `${item?.service_address?.address}, ${item?.service_address?.city}, ${item?.service_address?.state} ${item?.service_address?.zip_code}` : "-"}</h5>
          <span
            className="altude">{!isEmpty(item?.service_address?.geo_location?.latitude) ? `${item?.service_address?.geo_location?.latitude}, ${item?.service_address?.geo_location?.longitude}` : ``}</span>
          <div className="active_service_list">
            <div className="flex">
              <div>
                <b>Next Service</b>
                <span>{item?.next_service_date ? this.UTCToLocal(item?.next_service_date).format("ddd, MMM DD") : ""}</span>
              </div>
              <div>
                <b>Frequency</b>
                <span>{FREQUENCY_MAPPING[item?.frequency] && FREQUENCY_MAPPING[item?.frequency]}</span>
              </div>
              <div>
                <b>Last Service</b>
                <span>{item?.last_cleaned ? this.UTCToLocal(item?.last_cleaned).format("ddd, MMM DD") : ""}</span>
              </div>
            </div>
          </div>
          <hr />
          <div className="sdetail">
            <div className="subs">
              <strong>Subscription</strong>
              <span className=" d-flex justify-content-between">
                <div className="mr-2">
                  {map(orderBy(item?.commercial_detail?.line_items, "created_at", "asc"), (obj, index) => obj?.frequency !== "once" &&
                    <div
                      key={index}>{obj?.frequency && `${FREQUENCY_MAPPING[obj?.frequency]} service, `} {SERVICE_TYPE_MAPPING[obj?.item]}</div>)}
                </div>
                <strong>${total ? parseFloat(total).toFixed(2) : "0.00"}</strong>
              </span>
            </div>
          </div>
        </div>
        <div className="total flex plr-15">
          <h5>Total per visit (Incl. Tax)</h5>
          <h5>${total ? parseFloat(total).toFixed(2) : "0.00"}</h5>
        </div> */}
      </React.Fragment>
    );
  };

  // render service
  renderService = (item, index) => {
    return (
      <React.Fragment key={`service${index}`}>
        <div className="card">
          <div className="card-body pt-0">
            {this.renderServiceOverview(item)}
            <div className="plr-15">
              <button
                className="btn btn-warning btn-full mt-20 mb-10"
                onClick={() => this.onViewService(item)}
              >View Single Service
              </button>
              {item?.calculated_price?.is_prepaid &&
                <blockquote className="horiz">
                  <b>This service is on a pre-pay plan. This expires in the next 30 days.</b>
                  <p className="mb-0">This customer needs to update their pre-pay plan, or move to monthly payments.</p>
                </blockquote>}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  // render add new box
  renderAdditionalServiceBox = () => {
    const { tabChange } = this.props;
    return (
      <div className="card add-card">
        <h5>Want another service?</h5>
        <p>{`You'll need to create a proposal for a new commercial service.`}</p>
        <button className="btn btn-warning lg-btn" onClick={() => tabChange && tabChange(3, true)}>Create Proposal
        </button>
      </div>
    );
  };

  //Date range changed
  onDateRangeChange = (e) => {
    if (e) {
      this.setState({
        scheduled_time__range: `${moment(e[0]).format('YYYY-MM-DD hh:mm:ss')},${moment(e[1]).format('YYYY-MM-DD 23:59:59')}`
      }, () => {
        this.onFilterChange();
      })
    } else {
      this.setState({
        scheduled_time__range: null
      }, () => {
        this.onFilterChange();
      })
    }
  }

  //api call after filter and sorting
  onFilterChange = () => {
    const { customerId } = this.props;
    const { scheduled_time__range, service_order__uuid, work_order_number, technician__uuid, status, ordering, scheduled_time__gte, scheduled_time__lt, isServiceDetail, selectedService, currentSelectedService } = this.state;
    const queryParams = {
      service_order__user__uuid: `${customerId}`,
      scheduled_time__range: `${scheduled_time__range}`,
      service_order__uuid__in: service_order__uuid && service_order__uuid.length > 0 ? `${service_order__uuid.join()}` : null,
      work_order_number__in: work_order_number && work_order_number.length > 0 ? `${work_order_number}` : null,
      technician__uuid__in: technician__uuid && technician__uuid.length > 0 ? `${technician__uuid.join()}` : null,
      status__in: status && status.length > 0 ? `${status.join()}` : null,
      ordering: `${ordering}`,
      scheduled_time__gte: `${scheduled_time__gte}`,
      scheduled_time__lt: `${scheduled_time__lt}`
    }
    if (selectedService) {
      delete queryParams.service_order__uuid__in;
      queryParams['service_order__uuid'] = currentSelectedService?.uuid;
    } else {
      delete queryParams.service_order__uuid;
    }
    const params = this.filterParams(queryParams);
    this.props.getCommercialWorkOrderList(params);
    if (scheduled_time__lt) {
      this.props.getWorkOrderFilter({ service_order__user__uuid: customerId, service_order__uuid: selectedService?.uuid, scheduled_time__lt: `${scheduled_time__lt}` });
    }
    else if (scheduled_time__gte) {
      this.props.getWorkOrderFilter({ service_order__user__uuid: customerId, service_order__uuid: selectedService?.uuid, scheduled_time__gte: `${scheduled_time__gte}` });
    }
  }

  //Remove null object properties
  filterParams = (params) => {
    for (var propName in params) {
      if (params[propName] === "" || params[propName] === null || params[propName] === "null" || params[propName] === undefined || params[propName] === "undefined") {
        delete params[propName];
      }
    }
    return params
  }

  // render all service
  renderAllService = () => {
    const { serviceOrder } = this.state;
    return (
      <React.Fragment>
        <div className="flex singleservice">
          <ServiceList
            {...this}
            onViewService={(x) => {
              this.onViewService(x)
            }}
          />
          <div className="w-100">
            <div className="work-orders-table">
              <div className="work-orders-toolbar">
                <div className="table-header sorting-btn-group flex ai-center">
                  <h3 className="mb-0">Work Orders</h3>
                  <div className="sorting flex ai-center no-bdr">
                    {this?.props?.customer?.status !== "pending" && <><span className="mr-10">{this.countAppliedFilters()} filters applied</span>
                      <a role="button" href="/#" className="mr-10" onClick={(e) => { e.preventDefault(); this.clearAllFilters() }}>Clear all filters</a></>}
                    <button className={this.state?.viewType === "upcoming" ? "btn btn-upcoming" : "btn btn-history"} onClick={() => { this.upcomingWorkOrders() }}>Upcoming</button>
                    <button className={this.state?.viewType === "history" ? "btn btn-upcoming" : "btn btn-history"} onClick={() => { this.historyWorkOrders() }}>History</button>
                    {/* <button className="btn btn-brand btn-bdr flex ai-center" onClick={() => {  this.setState({showAddons: true, currentRecord: {} }) }}><img src={addGreenCircle} alt=""></img>Create Work Order 1</button> */}
                  </div>
                </div>
                {this?.props?.customer?.status !== "pending" && <div className="sorting sorting-fields flex no-bdr">
                  <div className="fitem date-range-field mr-10">
                    <label>Date Range</label>
                    <RangePicker
                      format='MMM D, YYYY'
                      defaultValue={(!!this.state.startDate && !!this.state.endDate) ? [moment(this.state.startDate), moment(this.state.endDate)] : []}
                      onChange={(e) => { this.onDateRangeChange(e) }}
                    />
                  </div>
                  <div className="fitem service-order-field mr-10">
                    <label>Service Order</label>
                    {this.renderServiceOrderFilters()}
                  </div>
                  <div className="fitem service-order-field mr-10">
                    <label>Work Order</label>
                    {this.renderWorkOrderFilters()}
                  </div>
                  <div className="fitem service-order-field mr-10">
                    <label>Technician</label>
                    {this.renderTechnicianFilters()}
                  </div>

                  <div className="fitem service-order-field">
                    <label>Status</label>
                    {this.renderStatusFilters()}
                  </div>
                </div>}
              </div>
              {this?.props?.customer?.status !== "pending" && this.renderWorkOrders(false)}
              {this?.props?.customer?.status === "pending" && <div style={{ textAlign: "center" }}>
                <p style={{ fontWeight: "bold" }}>
                  {this.state?.viewType === "upcoming" ? "No Upcoming Work Orders" : "No History Work Orders"}
                </p>
                <span>
                  Work orders will appear here when a service is active.
                </span>
              </div>}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  renderWorkOrders = (isFromSingleService) => {
    const { 
      CommercialWorkOrderList,
      workOrderListPagination,
      workOrderCount,
      viewType,
      isDeleteWOModalVisible,
      selectedService 
    } = this.state;

    return (
      <React.Fragment>
        <Table
          rowKey={record => record.uuid}
          className="tablebody"
          //rowClassName={isPausedApply ? "disabled-row" : null }
          dataSource={CommercialWorkOrderList}
          pagination={{ ...workOrderListPagination, total: workOrderCount }}
          columns={isFromSingleService ? selectedService?.commercial_order_line_item_type === 'service' ? viewType === 'upcoming' ? DataTable.UpComingWorkOrdersService(this) : DataTable.HistoryWorkOrdersService(this)
            : viewType === 'upcoming' ? DataTable.UpComingWorkOrdersProduct(this) : DataTable.HistoryWorkOrdersProduct(this) :
            viewType === 'upcoming' ? DataTable.UpComingWorkOrders(this) : DataTable.HistoryWorkOrders(this)}
          onChange={this.onWorkOrderHandleChange}
          position={false}
        />
        <Modal
          visible={isDeleteWOModalVisible}
          okText={"Delete"}
          cancelText={"Cancel"}
          onOk={() => {
            this.deleteWorkOrder()
            this.setState({ isDeleteWOModalVisible: false })
          }}
          onCancel={() => {
            this.setState({ isDeleteWOModalVisible: false })
          }}
          className="delete_user_modal"
          width={400}
        >
          <h3>{`Delete ${viewType === 'upcoming' ? "Upcoming" : "Past"} Work Order`}</h3>
          <p>{`Are you sure you would like to delete this ${viewType === 'upcoming' ? 'upcoming' : 'past'} work order?`}</p>
          <p>Any changes made to this work order will be lost.</p>
        </Modal>
      </React.Fragment>
    )
  }

  //Remove null object properties
  filterParams = (params) => {
    for (var propName in params) {
      if (params[propName] === "" || params[propName] === null || params[propName] === "null" || params[propName] === undefined || params[propName] === "undefined") {
        delete params[propName];
      }
    }
    return params
  }

  // on sorting selected
  onWorkOrderHandleChange = (pagination, filters, sorter) => {
    let ordering = ''
    if (sorter.column) {
      ordering = sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`
    } else {
      ordering = ''
    }

    if (ordering) {
      this.setState({ ordering: ordering }, () => {
        this.onFilterChange();
      });
    } else {
      this.setState({ ordering: '' }, () => {
        this.onFilterChange();
      });
    }
  }

  upcomingWorkOrders = () => {
    const { customerId } = this.props;
    this.setState({ viewType: 'upcoming', scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), scheduled_time__lt: null }, () => {
      this.onFilterChange();
      // this.props.getWorkOrderFilter({ service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss") });
    });
  }

  historyWorkOrders = () => {
    this.setState({ viewType: 'history', scheduled_time__lt: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), scheduled_time__gte: null, ordering: 'scheduled_time' }, () => {
      this.onFilterChange();
    });
  }

  //#region "Service Order Filter"
  renderServiceOrderFilters = () => {
    const { toggleServiceOrderFilter, serviceOrderFilter, service_order__uuid } = this.state;
    return (
      <ServiceOutsideAlerter
        closeServiceOrderFilter={this.closeServiceOrderFilter}
      >
        <div className="form-group image-input">
          <div className="fitem">
            <input type="text" id="txtServiceOrder" placeholder={service_order__uuid && service_order__uuid.length === 0 ? 'All' : `${service_order__uuid.length} items selected`} onChange={(e) => { this.onSearchServiceOrder(e) }} onFocus={() => { this.toggleServiceOrder() }} />
            {service_order__uuid && service_order__uuid.length === 0 &&
              <img src={chevronDown} alt="" onClick={() => { this.toggleServiceOrder() }} />
            }
            {service_order__uuid && service_order__uuid.length > 0 &&
              <img src={close} alt="" onClick={() => { this.clearServiceOrder() }} />
            }
          </div>
          {toggleServiceOrderFilter && <div className="field-dropdown">
            <div className="field-dropdown-body">
              <div className="fitem-check">
                <input id="allServiceOrder" type="checkbox" className="fitem-ck-input" checked={this.state?.allServiceOrderSelected} onChange={(e) => { this.onServiceOrderChanged(e, null, true) }} />
                <label htmlFor="allServiceOrder" className="fitem-ck-txt">All Service Orders</label>
              </div>
              {map(serviceOrderFilter, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input id={item.uuid} type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onServiceOrderChanged(e, index) }} checked={this.state?.service_order__uuid?.includes(item?.uuid)} /> {/* checked={item.is_change} */}
                    <label htmlFor={item.uuid} className="fitem-ck-txt">{item.service_order_number}</label>
                    <span className="fcheck-span">{item?.service_address?.formatted_address}</span>
                  </div>
                )
              })}
            </div>
            <div className="flex ai-center field-dropdown-footer">
              <button className="btn btn-brand btn-bdr btn-full mr-5" onClick={() => { this.clearServiceOrder() }}>Clear</button>
              <button className="btn btn-primary btn-full ml-5 mt-0" onClick={() => { this.onFilterChange(); this.setState({ toggleServiceOrderFilter: false }) }}>Update</button>
            </div>
          </div>}
        </div>
      </ServiceOutsideAlerter>
    )
  }

  toggleServiceOrder = () => {
    const { toggleServiceOrderFilter } = this.state;
    if (toggleServiceOrderFilter) {
      this.setState({ toggleServiceOrderFilter: false })
    } else {
      this.setState({ toggleServiceOrderFilter: true, toggleWorkOrderFilter: false, toggleTechnicianFilter: false, toggleStatusFilter: false })
    }
  }

  onSearchServiceOrder = (e) => {
    const { serviceOrderFilter } = this.state;
    if (e.target.value) {
      const data = serviceOrderFilter.filter((obj) => {
        return obj.service_order_number.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1
      });
      this.setState({ serviceOrderFilter: data });
    } else {
      this.props.getServiceOrderFilter({ service_order__user__uuid: this.props.customerId });
    }
  }

  onServiceOrderChanged = (e, index, isAll = false) => {
    const { serviceOrderFilter, service_order__uuid, allServiceOrderSelected } = this.state;
    var arrServiceUuid = [...service_order__uuid];

    if (isAll) {
      if (e.target.checked) {
        arrServiceUuid = serviceOrderFilter.map(item => item.uuid);
        document.getElementById("allServiceOrder").checked = true;
      } else {
        arrServiceUuid = [];
        document.getElementById("allServiceOrder").checked = false;
      }
    } else {
      if (e.target.checked) {
        // case where we want to toggle select all
        if (index === null) {
          arrServiceUuid = [];
          serviceOrderFilter.forEach(element => {
            element['is_change'] = !allServiceOrderSelected
            if (!allServiceOrderSelected) {
              arrServiceUuid.push(element?.uuid)
            }
          });
        } else {
          if (arrServiceUuid.indexOf(e.target.id) === -1) {
            document.getElementById("allServiceOrder").checked = false;
            arrServiceUuid.push(e.target.id)
            serviceOrderFilter[index]['is_change'] = true;
          }
        }
      } else {
        if (index === null) {
          arrServiceUuid = [];
          serviceOrderFilter.forEach(element => {
            element['is_change'] = false
          });
        } else {
          const ind = arrServiceUuid.indexOf(e.target.id);
          if (ind > -1) {
            arrServiceUuid.splice(ind, 1);
            serviceOrderFilter[index]['is_change'] = false;
            document.getElementById("allServiceOrder").checked = false;
          }
        }
      }
    }

    this.setState({
      service_order__uuid: arrServiceUuid,
      // if All Service Order is selected then we toggle or we unset the allServiceOrderSelected flag.
      allServiceOrderSelected: (index === null) ? !allServiceOrderSelected : false
    }, () => {
      // console.warn('service_order__uuid', this.state.service_order__uuid);
    });
  }

  clearServiceOrder = () => {
    const { serviceOrderFilter } = this.state;
    if (document.getElementById("allServiceOrder")) {
      document.getElementById("allServiceOrder").checked = false
    }
    serviceOrderFilter.forEach(element => {
      element['is_change'] = false;
    });
    this.setState({ service_order__uuid: [], toggleServiceOrderFilter: false, allServiceOrderSelected: false }, () => {
      this.onFilterChange()
    });
  }

  closeServiceOrderFilter = () => {
    this.setState({ toggleServiceOrderFilter: false })
  }

  //#endregion

  //#region "Work Order Filter"
  renderWorkOrderFilters = () => {
    const { toggleWorkOrderFilter, workOrderFilter, work_order_number, woSearch = '' } = this.state;
    return (
      <WorkOrderOutsideAlerter
        closeWorkOrderFilter={this.closeWorkOrderFilter}
      >
        <div className="form-group image-input">
          <div className="fitem">
            <input type="text" id="txtWorkOrder"
              onChange={(e) => {
                this.setState({ woSearch: e.target.value })
              }}
              placeholder={work_order_number && work_order_number.length === 0 ? 'All' : `${work_order_number.length} items selected`}
              onFocus={() => { this.toggleWorkOrder() }}
            />
            {work_order_number && work_order_number.length === 0 &&
              <img src={chevronDown} alt="" onClick={() => { this.toggleWorkOrder() }} />
            }
            {work_order_number && work_order_number.length > 0 &&
              <img src={close} alt="" onClick={() => { this.clearWorkOrder() }} />
            }
          </div>
          {toggleWorkOrderFilter && <div className="field-dropdown">
            <div className="field-dropdown-body">
              <div className="fitem-check">
                <input id="allWorkOrder" type="checkbox" className="fitem-ck-input" checked={this.state?.allWorkOrderSelected} onChange={(e) => { this.onWorkOrderChanged(e, null, true) }} />
                <label htmlFor="allWorkOrder" className="fitem-ck-txt">All Work Orders</label>
              </div>
              {map(workOrderFilter.filter(wo => ((wo?.address + wo?.work_order_number).includes(woSearch))), (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input id={item?.uuid} type="checkbox" value={item?.work_order_number} className="fitem-ck-input chkWorkOrder" onChange={(e) => { this.onWorkOrderChanged(e, index) }} checked={this?.state?.work_order_number?.includes(item?.work_order_number)} /> {/* checked={item.is_change} */}
                    <label htmlFor={item?.uuid} className="fitem-ck-txt">{item?.work_order_number}</label>
                    <span className="fcheck-span">{item?.address}</span>
                  </div>
                )
              })}
            </div>
            <div className="flex ai-center field-dropdown-footer">
              <button className="btn btn-brand btn-bdr btn-full mr-5" onClick={() => { this.clearWorkOrder() }}>Clear</button>
              <button className="btn btn-primary btn-full ml-5 mt-0" onClick={() => { this.onFilterChange(); this.setState({ toggleWorkOrderFilter: false }) }}>Update</button>
            </div>
          </div>}
        </div>
      </WorkOrderOutsideAlerter>
    )
  }

  toggleWorkOrder = () => {
    const { toggleWorkOrderFilter } = this.state;
    if (toggleWorkOrderFilter) {
      this.setState({ toggleWorkOrderFilter: false })
    } else {
      this.setState({ toggleWorkOrderFilter: true, toggleServiceOrderFilter: false, toggleTechnicianFilter: false, toggleStatusFilter: false })
    }
  }

  onWorkOrderChanged = (e, index, isAll = false) => {
    const { workOrderFilter, work_order_number, allWorkOrderSelected } = this.state;
    let arrWorkOrderNumber = [...work_order_number];

    if (isAll) {
      if (e.target.checked) {
        arrWorkOrderNumber = workOrderFilter.map(item => item.work_order_number);
        document.getElementById("allWorkOrder").checked = true;
      } else {
        arrWorkOrderNumber = [];
        document.getElementById("allWorkOrder").checked = false;
      }
    } else {
      if (e.target.checked) {
        if (index === null) {
          arrWorkOrderNumber = [];
          workOrderFilter.forEach(element => {
            element['is_change'] = !allWorkOrderSelected
            if (!allWorkOrderSelected) {
              arrWorkOrderNumber.push(element?.work_order_number)
            }
          });
        } else {
          if (arrWorkOrderNumber.indexOf(e.target.value) === -1) {
            document.getElementById("allWorkOrder").checked = false;
            arrWorkOrderNumber.push(e.target.value);
            workOrderFilter[index]['is_change'] = true;
          }
        }
      } else {
        if (index === null) {
          arrWorkOrderNumber = [];
          workOrderFilter.forEach(element => {
            element['is_change'] = false
          });
        } else {
          const ind = arrWorkOrderNumber.indexOf(e.target.value);
          if (ind > -1) {
            arrWorkOrderNumber.splice(ind, 1);
            workOrderFilter[index]['is_change'] = false;
            document.getElementById("allWorkOrder").checked = false;
          }
        }
      }
    }

    this.setState({ work_order_number: arrWorkOrderNumber, allWorkOrderSelected: index === null ? !allWorkOrderSelected : false }, () => {
      // console.warn('work_order_number', this.state.work_order_number);
    });
  }

  clearWorkOrder = () => {
    const { workOrderFilter } = this.state;
    workOrderFilter.forEach(element => {
      element['is_change'] = false;
    });
    if (document.getElementById("allWorkOrder")) {
      document.getElementById("allWorkOrder").checked = false;
    }
    this.setState({ work_order_number: [], toggleWorkOrderFilter: false, allWorkOrderSelected: false }, () => {
      this.onFilterChange()
    });
  }

  closeWorkOrderFilter = () => {
    const { editService } = this.state;
    if (editService !== true) {
      this.setState({ toggleWorkOrderFilter: false })
    }
  }

  //#endregion

  //#region "Technician Filter"
  renderTechnicianFilters = () => {
    const { toggleTechnicianFilter, FieldTechnician, technician__uuid } = this.state;
    return (
      <TechnicianOutsideAlerter
        closeTechnicianFilter={this.closeTechnicianFilter}
      >
        <div className="form-group image-input">
          <div className="fitem">
            <input type="text" id="txtTechnician" placeholder={technician__uuid && technician__uuid.length === 0 ? 'All' : `${technician__uuid.length} items selected`} onChange={(e) => { this.onSearchTechnician(e) }} onFocus={() => { this.toggleTechnician() }} />
            {technician__uuid && technician__uuid.length === 0 &&
              <img src={chevronDown} alt="" onClick={() => { this.toggleTechnician() }} />
            }
            {technician__uuid && technician__uuid.length > 0 &&
              <img src={close} alt="" onClick={() => { this.clearTechnician() }} />
            }
          </div>
          {toggleTechnicianFilter && <div className="field-dropdown">
            <div className="field-dropdown-body">
              <div className="fitem-check">
                <input id="allTech" type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onTechnicianChanged(e, null) }} />
                <label htmlFor="allTech" className="fitem-ck-txt">All Technicians</label>
              </div>
              {map(FieldTechnician, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input id={item?.uuid} type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onTechnicianChanged(e, index) }} checked={item.is_change} /> {/* checked={item.is_change} */}
                    <label htmlFor={item?.uuid} className="fitem-ck-txt">{item?.user?.first_name}, {item?.user?.last_name}</label>
                  </div>
                )
              })}
            </div>
            <div className="flex ai-center field-dropdown-footer">
              <button className="btn btn-brand btn-bdr btn-full mr-5" onClick={() => { this.clearTechnician() }}>Clear</button>
              <button className="btn btn-primary btn-full ml-5 mt-0" onClick={() => { this.onFilterChange(); this.setState({ toggleTechnicianFilter: false }) }}>Update</button>
            </div>
          </div>}
        </div>
      </TechnicianOutsideAlerter>
    )
  }

  toggleTechnician = () => {
    const { toggleTechnicianFilter } = this.state;
    if (toggleTechnicianFilter) {
      this.setState({ toggleTechnicianFilter: false })
    } else {
      this.setState({ toggleTechnicianFilter: true, toggleServiceOrderFilter: false, toggleWorkOrderFilter: false, toggleStatusFilter: false })
    }
  }

  onSearchTechnician = (e) => {
    const { FieldTechnician } = this.state;
    if (e.target.value) {
      const data = FieldTechnician.filter((obj) => {
        return (obj.user.last_name.toLowerCase()).indexOf(e.target.value.toLowerCase()) > -1
      });
      this.setState({ FieldTechnician: data });
    } else {
      this.props.getFieldTechnicianFilter();
    }
  }

  onTechnicianChanged = (e, index) => {
    const { FieldTechnician, technician__uuid, allTechnicianSelected } = this.state;
    let arrTechnicianUuid = [...technician__uuid];
    if (e.target.checked) {
      if (index === null) {
        arrTechnicianUuid = [];
        FieldTechnician.forEach(element => {
          element['is_change'] = !allTechnicianSelected;
          if (!allTechnicianSelected) {
            arrTechnicianUuid.push(element?.uuid);
          }
        });
      } else {
        if (arrTechnicianUuid.indexOf(e.target.id) === -1) {
          document.getElementById("allTech").checked = false;
          arrTechnicianUuid.push(e.target.id)
          FieldTechnician[index]['is_change'] = true;
        }
      }
    } else {
      if (index === null) {
        arrTechnicianUuid = [];
        FieldTechnician.forEach(element => {
          element['is_change'] = false
        });
      } else {
        const ind = arrTechnicianUuid.indexOf(e.target.id);
        if (ind > -1) {
          arrTechnicianUuid.splice(ind, 1);
          FieldTechnician[index]['is_change'] = false;
          document.getElementById("allTech").checked = false;
        }
      }
    }
    this.setState({ technician__uuid: arrTechnicianUuid, allTechnicianSelected: index === null ? !allTechnicianSelected : false }, () => {
      // console.warn('technician__uuid', this.state.technician__uuid);
    });
  }

  clearTechnician = () => {
    const { FieldTechnician } = this.state;
    FieldTechnician.forEach(element => {
      element['is_change'] = false;
    });
    if (document.getElementById("allTech")) {
      document.getElementById("allTech").checked = false
    }
    this.setState({ technician__uuid: [], toggleTechnicianFilter: false }, () => {
      this.onFilterChange()
    });
  }

  closeTechnicianFilter = () => {
    const { editService } = this.state;

    if (editService !== true) {
      this.setState({ toggleTechnicianFilter: false })
    }
  }

  //#endregion 

  //#region "Status Filter"
  renderStatusFilters = () => {
    const { toggleStatusFilter, status } = this.state;

    return (
      <StatusOutsideAlerter
        closeStatusFilter={this.closeStatusFilter}
      >
        <div className="form-group image-input">
          <div className="fitem">
            <input type="text" id="txtStatus" placeholder={status && status.length === 0 ? 'All' : `${status.length} items selected`} onFocus={() => { this.toggleStatus() }} />
            {status && status.length === 0 &&
              <img src={chevronDown} alt="" onClick={() => { this.toggleStatus() }} />
            }
            {status && status.length > 0 &&
              <img src={close} alt="" onClick={() => { this.clearStatus() }} />
            }
          </div>
          {toggleStatusFilter && <div className="field-dropdown right">
            <div className="field-dropdown-body">
              {map(workOrderStatus.WorkOrderStatus, (item, index) => {
                return (
                  <div key={index} className="fitem-check">
                    <input id={item.value} type="checkbox" className="fitem-ck-input" onChange={(e) => { this.onStatusChanged(e, index) }} checked={item.is_change} />
                    <label htmlFor={item.value} className="fitem-ck-txt">{item.label}</label>
                  </div>
                )
              })}
            </div>
            <div className="flex ai-center field-dropdown-footer">
              <button className="btn btn-brand btn-bdr btn-full mr-5" onClick={() => { this.clearStatus() }}>Clear</button>
              <button className="btn btn-primary btn-full ml-5 mt-0" onClick={() => { this.onFilterChange(); this.setState({ toggleStatusFilter: false }) }}>Update</button>
            </div>
          </div>}
        </div>
      </StatusOutsideAlerter>
    )
  }

  toggleStatus = () => {
    const { toggleStatusFilter } = this.state;
    if (toggleStatusFilter) {
      this.setState({ toggleStatusFilter: false })
    } else {
      this.setState({ toggleStatusFilter: true, toggleServiceOrderFilter: false, toggleWorkOrderFilter: false, toggleTechnicianFilter: false })
    }
  }

  onStatusChanged = (e, index) => {
    const { status } = this.state;
    let arrStatus = [...status];
    if (e.target.checked) {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach((element, index) => {
          element['is_change'] = true;
          if (index > 0 && arrStatus.indexOf(element.value) === -1) {
            arrStatus.push(element.value)
          }
        });
      } else {
        if (arrStatus.indexOf(e.target.id) === -1) {
          workOrderStatus.WorkOrderStatus[index]['is_change'] = true;
          arrStatus.push(e.target.id)
        }
      }
    } else {
      if (index === 0) {
        workOrderStatus.WorkOrderStatus.forEach(element => {
          element['is_change'] = false;
        });
        arrStatus = []
      } else {
        const ind = arrStatus.indexOf(e.target.id);
        if (ind > -1) {
          workOrderStatus.WorkOrderStatus[0]['is_change'] = false;
          workOrderStatus.WorkOrderStatus[index]['is_change'] = false;
          arrStatus.splice(ind, 1);
        }
      }
    }
    this.setState({ status: arrStatus }, () => {
      // console.warn('status', this.state.status);
    });
  }

  clearStatus = () => {
    workOrderStatus.WorkOrderStatus.forEach(element => {
      element['is_change'] = false;
    });
    this.setState({ status: [], toggleStatusFilter: false }, () => {
      this.onFilterChange()
    });
  }

  closeStatusFilter = () => {
    const { editService } = this.state;

    if (editService !== true) {
      this.setState({ toggleStatusFilter: false })
    }
  }

  //#endregion

  countAppliedFilters = () => {
    const { scheduled_time__range, service_order__uuid, work_order_number, technician__uuid, status } = this.state;
    const queryParams = {
      scheduled_time__range: `${scheduled_time__range}`,
      service_order__uuid__in: service_order__uuid && service_order__uuid.length > 0 ? `${service_order__uuid.join()}` : null,
      work_order_number__in: work_order_number && work_order_number.length > 0 ? `${work_order_number}` : null,
      technician__uuid__in: technician__uuid && technician__uuid.length > 0 ? `${technician__uuid.join()}` : null,
      status__in: status && status.length > 0 ? `${status.join()}` : null,
    }
    const params = this.filterParams(queryParams);
    return Object.keys(params).length
  }

  clearAllFilters = () => {
    const { customerId } = this.props;
    this.setState({
      scheduled_time__range: null,
      service_order__uuid: [],
      work_order_number: [],
      technician__uuid: [],
      status: []
    }, () => {
      this.clearServiceOrder();
      this.clearWorkOrder();
      this.clearTechnician();
      this.clearStatus();
      this.props.getCommercialWorkOrderList({ service_order__user__uuid: `${customerId}`, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss") });
      this.props.getWorkOrderFilter({ service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss") });

    });
  }

  //render Service Details
  renderServiceDetails = (item, index) => {
    let { selectedService, unavailableDays } = this.state;
    if (selectedService?.uuid === item?.uuid) {
      return (
        <React.Fragment key={`serviceDetail${index}`}>
          <div className="card mt-10">
            <div className="card-body">
              <h5>Service Overview</h5>
              <div className="sdetail">
                <div className="subs flex">
                  <b>Product/Service</b>
                  <p>{map(item?.commercial_detail?.line_items, (a, index) => <span
                    key={`Detail${SERVICE_TYPE_MAPPING[a.item]}${index}`}>{`${SERVICE_TYPE_MAPPING[a.item]}, `}</span>)}</p>
                </div>
              </div>
              <div className="sdetail flex">
                <div className="subs flex-1">
                  <b>Pet Waste Bag Type </b>
                  {
                    map(item?.commercial_detail?.bag_type, (x) => {
                      return `${BAGS[x]}, `;
                    })
                  }

                </div>
                <div className="subs flex-1">
                  <b>Avg. Number of Bags</b>
                  {item?.disposal_location || "-"}
                </div>
              </div>
              <strong>Preferred Service Days</strong>
              <span className="d-block">Select the days you are available for services.</span>
              <div className="inline-check-list mt-10 col-count-2">
                {
                  map(unavailableDays, (item, i) =>
                    <div className="fitem-check" key={i}>
                      <input
                        type="checkbox" name="checked"
                        checked={!item?.checked}
                        id={`days${i}`}
                        onChange={(e) => this.onChangeDay(e, i)}
                        className="fitem-ck-input"
                      />
                      <label className="fitem-ck-txt" htmlFor={`days${i}`}>{item?.value}</label>
                    </div>,
                  )
                }
              </div>
              <button
                type="button"
                className="btn btn-brand btn-bdr btn-full"
                onClick={() => this.onUpdateDays()}
              >Update Service Days
              </button>
            </div>
          </div>

        </React.Fragment>
      );
    }
  };

  // render service history table
  serviceHistoryTable = () => {
    const { selectedHistory, historyPagination, historyCount } = this.state;

    return (
      <React.Fragment>
        <Table
          rowKey={record => record.uuid}
          rowClassName={(record) => {
            if (record.status === "cancelled") {
              return "cancelled";
            }
          }}
          dataSource={selectedHistory}
          pagination={{ ...historyPagination, total: historyCount }}
          onChange={this.handleTableChange}
          columns={DataTable.Service(this)}
          onRow={(record) => ({
            onClick: () => {
              this.setState({ currentHistory: record }, () => {
                this.props.getServiceHistory({ service__uuid: record?.uuid })
                this.toggleViewHistory(true)
              });
            },
          })}
          className="tablebody service_history_table"
        />

      </React.Fragment>);
  };

  /**
   * AUTHOR: SHARAD TAUR
   * <DP-3190>Delete a Work Order for a Residential Customer</DP-3190>
   */
  deleteWorkOrder = () => {
    const { currentRecord } = this.state;
    axios.delete(`/service-ftech/${currentRecord?.uuid}/`).then((response) => {
      message.success(`Work order ${currentRecord?.work_order_number || ""} deleted.`, 10);
      this.onFilterChange();
    }).catch(error => {
      message.error(`Error occurred while deleting Work order.`, 10);
    });
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-4023></DP-4023>
   */
  setIsModalVisible = (isModalVisible) => {
    this.setState({
      isModalVisible: isModalVisible
    })
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-4023></DP-4023>
   */
  deactivateServiceOrder = () => {
    const { selectedService } = this.state;
    axios.patch(`/partial-service-order/${selectedService?.uuid}/`, {
      is_active: false,
    }).then((response) => {
      const { customerId } = this.props;
      this.props.getCommercialWorkOrderList({ service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time' });
      this.setIsModalVisible(false);
      message.success(`Service Order ${selectedService?.service_order_number} is now inactive.`, 10);
      this.props.rerender();
      this.onChangeView(0);
    }).catch(error => {
      message.error(`Error occurred while Deactivating a Service Order.`, 10);
    });
  }

  /**
   * AUTHOR: Ritesh Solanki
   * <DP-4023></DP-4023>
   */
  reactivateServiceOrder = () => {
    const { selectedService, preferred_start_date } = this.state;
    if (selectedService?.frequency === 'once') {
      axios.patch(`/partial-service-order/${selectedService?.uuid}/`, {
        is_active: true,
      }).then((response) => {
        const { customerId } = this.props;
        this.props.getCommercialWorkOrderList({ service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time' });
        this.setIsModalVisible(false);
        message.success(`Service Order ${selectedService?.service_order_number} is now active.`, 10);
        this.props.rerender();
        this.onChangeView(0);
      }).catch(error => {
        message.error(`Error occurred while Deactivating a Service Order.`, 10);
      });
    } else {
      const schema = yup.object().shape({
        preferred_start_date: yup.string().required('Please select a service date.')
      });
      const data = { preferred_start_date };
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState(s => ({ errors: {} }));
        axios.patch(`/partial-service-order/${selectedService?.uuid}/`, { is_active: true, preferred_start_date: moment(preferred_start_date, 'DD-MM-YYYY').format("YYYY-MM-DD") }).then((response) => {
          const { customerId } = this.props;
          this.props.getCommercialWorkOrderList({ service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time' });
          this.setIsModalVisible(false);
          message.success(`Service Order ${selectedService?.service_order_number} is now active.`, 10);
          this.props.rerender();
          this.onChangeView(0);
        }).catch(error => {
          message.error(`Error occurred while reactivating service order.`, 10);
        });
      }).catch((error) => {
        let err_data = {};
        map(error.inner, (item) => { err_data[item.path] = item.message });
        this.setState(s => ({ errors: err_data }));
      })
    }
  }

  //render selected service
  renderSelectedService = () => {
    const { serviceOrder, currentSelectedService, historyPagination, isModalVisible, preferred_start_date, errors } = this.state;
    const selectedService = currentSelectedService || this.state.selectedService;
    const { commercial_detail } = selectedService;
    const { line_items } = { ...commercial_detail };
    const { customerId } = this.props;
    var result = [];
    if (line_items && line_items.length > 0) {
      line_items.reduce(function (res, value) {
        if (!res[value.item]) {
          res[value.item] = { item: value.item, total: 0 };
          result.push(res[value.item])
        }
        res[value.item].total += +value.total;
        return res;
      }, {});
    }

    return (
      <React.Fragment>
        <Observer
          {...this}
          setState={this.setState.bind(this)}
        />
        <div className="filter_wrapper">
          <ul className="breadcrumb">
            <li className={"cursor_pointer"}><span onClick={() => {
              this.onChangeView(0);
              if (customerId) {
                this.setState({
                  scheduled_time__range: null,
                  service_order__uuid: [],
                  work_order_number: [],
                  technician__uuid: [],
                  status: [],
                  isServiceDetail: false,
                  viewType: 'upcoming',
                  scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), scheduled_time__lt: null,
                  currentSelectedService: null,
                  selectedService: null
                }, () => {
                  workOrderStatus.WorkOrderStatus.forEach(element => {
                    element['is_change'] = false;
                  });
                  // this.props.viewServiceDetail(false, {});
                  this.onFilterChange();
                  this.props.getServiceOrder({ user__uuid: customerId });
                  //   this.props.getFieldTechnicianFilter();
                  //   this.props.getWorkOrderFilter({ service_order__user__uuid: customerId, service_order__uuid: selectedService?.uuid, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss") });
                  //   this.props.getCommercialWorkOrderList({ service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss") });
                })
              }
            }}>Services</span></li>
            <li>
              <span>{(!isEmpty(selectedService?.service_address) && !isEmpty(selectedService?.service_address?.address)) ? `${selectedService?.service_address?.address}, ${selectedService?.service_address?.city}, ${selectedService?.service_address?.state} ${selectedService?.service_address?.zip_code}` : "-"}</span>
            </li>
          </ul>
        </div>
        <div className="flex singleservice">
          <div className="card-col service-order-card">
            <div className="card">
              <div className="card-body">
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                }}>
                  <p style={{
                    fontSize: 12,
                    color: "#1F1F25",
                    marginBottom: 8,
                  }}>{selectedService?.service_order_number}
                    <span style={{
                      paddingLeft: 10,
                      color: "#1F1F25",
                      opacity: 0.5,
                    }}>{`${selectedService?.community_nickname ? selectedService?.community_nickname + "-" : ""}${setRecurring(selectedService?.frequency)}`}</span>
                  </p>
                  <p style={{
                    color: "#1F1F25",
                    fontSize: 15,
                    fontWeight: "bold",
                    marginBottom: 10,
                    display: "flex",
                    justifyContent: "space-between",
                  }}>
                    <span>
                      {
                        (!isEmpty(selectedService?.service_address) && !isEmpty(selectedService?.service_address?.address)) ? 
                          `${selectedService?.service_address?.address}, ${selectedService?.service_address?.city}, ${selectedService?.service_address?.state} ${selectedService?.service_address?.zip_code}`
                          : "-"
                      }
                    </span>
                    {
                      selectedService?.is_active ? selectedService?.is_paused ? 
                        <span className="status warning-status drk" style={{ height: 27 }}>Paused</span>
                        : <span className="status success-status drk" style={{ height: 27 }}>Active</span>
                        : <span className="status gray-status drk" style={{ height: 27 }}>INACTIVE</span>
                    }
                  </p>
                  <p style={{
                    fontSize: 11,
                    color: "#252730",
                    opacity: 0.5,
                  }}>
                    {!!selectedService?.service_address?.geo_location && `${selectedService?.service_address?.geo_location?.latitude}, ${selectedService?.service_address?.geo_location?.longitude}`}
                  </p>
                </div>
                {this.renderServiceOverview(selectedService)}
                <div className="flex mt-10">
                  <button className="btn btn-warning mb-10"
                    style={{
                      fontSize: 12,
                    }}
                    onClick={() => this.toggleEditService(true)}>Edit this Service Order
                  </button>
                  {(selectedService?.commercial_order_line_item_type === "service" && selectedService?.is_active && !selectedService?.is_paused) && <button className="btn btn-brand btn-bdr flex ai-center justify-content-center px-10" onClick={() => {
                    this.props.getPauseService({ service_order__uuid: selectedService?.uuid }); // Get pause service list
                    this.props.getPauseReason();// get pause reason
                    this.togglePauseService(true);
                    // this.setState({selectedView: 2})
                  }}>
                    <img className="mr-5" src={pauseIcon} alt="" />
                    Pause
                  </button>}
                  {/* <button className="dots-button mt-20 mb-10">
                    <span />
                    <span />
                    <span />
                  </button> */}
                  <div className="dropdown">
                    <div className="position-relative pause-dropdown">
                      {
                        !!this?.props?.customer?.is_active && <>
                          <button className="dots-button mb-10"><span></span><span></span><span></span></button>
                          <ul className="pause-dropdownmenu" style={{ width: 200 }}>
                            {
                              !selectedService?.is_active
                                ?
                                <li><a onClick={() => { this.setIsModalVisible(true) }}>Reactivate Service Order</a></li>
                                : <li><a onClick={() => { this.setIsModalVisible(true) }}>Deactivate Service Order</a></li>
                            }
                          </ul>
                        </>
                      }
                      <Modal
                        visible={isModalVisible}
                        okText={`${selectedService?.is_active ? 'Deactivate' : 'Reactivate'}`}
                        cancelText={"Cancel"}
                        onOk={() => {
                          if (selectedService?.is_active) {
                            this.deactivateServiceOrder();
                            // setTimeout(() => {
                            //   this.setIsModalVisible(false)
                            // }, 1500)
                          } else {
                            this.reactivateServiceOrder();
                          }
                        }}
                        onCancel={() => {
                          this.setState({
                            preferred_start_date: '',
                            errors: {}
                          })
                          this.setIsModalVisible(false);
                        }}
                        className="delete_user_modal"
                        width={400}
                      >
                        <h3>{`${selectedService?.is_active ? 'Deactivate' : 'Reactivate'} Service Order`}</h3>
                        <p>{`Are you sure you would like to ${selectedService?.is_active ? 'deactivate' : 'reactivate'} this service order?`}</p>
                        {selectedService?.is_active &&
                          <React.Fragment>
                            <p>
                              All Forecast work orders will be cancelled and deleted.
                              Any Scheduled work orders will need to be determined manually
                            </p>
                          </React.Fragment>
                        }
                        {!selectedService?.is_active && selectedService?.frequency !== 'once' &&
                          <React.Fragment>
                            <p>Please specify the date to resume service at this location.</p>
                            <div className="field-group">
                              <label>Next Service<sup>*</sup></label>
                              <DatePicker
                                style={{ 'width': '100%' }}
                                format="YYYY-MM-DD"
                                name='preferred_start_date'
                                disabledDate={(current) => { return current && current <= moment().endOf('day'); }}
                                suffixIcon={<i className="las la-calendar"></i>}
                                allowClear={true}
                                value={preferred_start_date}
                                onChange={(e) => {
                                  if (e) {
                                    this.setState(s => ({ preferred_start_date: e }))
                                  } else {
                                    this.setState(s => ({ preferred_start_date: '' }))
                                  }
                                }}
                              />
                              {errors?.['preferred_start_date'] ? <label className="new_err_msg"><i className="las la-info-circle" />{errors?.['preferred_start_date']}</label> : ''}
                            </div>
                          </React.Fragment>
                        }
                      </Modal>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  {/* {
                    JSON.stringify(selectedService?.commercial_detail) 
                  } */}
                  <p
                    style={{
                      color: "#1F1F25",
                      fontFamily: "Lato",
                      fontSize: 15,
                      fontWeight: "bold"
                    }}
                  >
                    Service Details
                  </p>
                  <span style={{
                    "color": "#6F6F6F",
                    "fontFamily": "Lato",
                    "fontSize": "13px",
                    "letterSpacing": "0",
                    "lineHeight": "18px",
                    "display": "block",
                    "marginBottom": "4px"
                  }}>Services</span>
                  {
                    result?.map((item, i) => {
                      return (
                        <React.Fragment key={i}>
                          <div className="flex mb-8" style={{
                            justifyContent: "space-between",
                          }}>
                            <span className="lh-16"
                              style={{
                                "color": "#252730",
                                "fontFamily": "Lato",
                                "fontSize": "13px"
                              }}
                            >{SERVICE_TYPE_MAPPING[item?.item]}</span>
                            <span className="lh-16"
                              style={{
                                "color": "#252730",
                                "fontFamily": "Lato",
                                "fontSize": "13px"
                              }}
                            >${item?.total}</span>
                          </div>
                        </React.Fragment>
                      )
                    })
                  }
                  <p className="flex mb-8" style={{
                    justifyContent: "space-between",
                  }}>
                    <span className="lh-16" style={{
                      "color": "#22232A",
                      "fontFamily": "Lato",
                      "fontSize": "13px",
                      "fontWeight": "bold"
                    }}>
                      Service Order Total (excl. tax)
                    </span>
                    <span className="lh-16" style={{
                      "color": "#22232A",
                      "fontFamily": "Lato",
                      "fontSize": "13px",
                      "fontWeight": "bold"
                    }}>
                      ${(+selectedService?.commercial_detail?.total)}
                    </span>
                  </p>
                  <p
                    style={{
                      color: "#6F6F6F",
                      fontFamily: "Lato",
                      fontSize: 13,
                      marginBottom: 8,
                    }}
                  >
                    Average Clean Time
                  </p>
                  <p
                    style={{
                      color: "#22232A",
                      fontFamily: "Lato",
                      fontSize: 13
                    }}
                  >
                    {
                      selectedService?.average_clean_time
                    }
                  </p>
                  <p
                    style={{
                      color: "#6F6F6F",
                      fontFamily: "Lato",
                      fontSize: 13,
                      marginBottom: 8,
                    }}
                  >
                    Preferred Technician
                  </p>
                  <p
                    style={{
                      color: "#22232A",
                      fontFamily: "Lato",
                      fontSize: 13
                    }}
                  >
                    {
                      selectedService?.preferred_technician?.user?.first_name && 
                      <span className="service-type-body">{`${selectedService?.preferred_technician?.user?.first_name} ${selectedService?.preferred_technician?.user?.last_name}`}</span>
                    }
                    {
                      !selectedService?.preferred_technician?.user?.first_name && 
                      <span className="service-type-body">None</span>
                    }
                  </p>
                </div>
                {/* <div className="btn-group p-0 flex">
                  <button className="btn btn-warning flex-1" onClick={() => this.toggleRequestRepair(true)}>Request a
                    Repair
                  </button>
                  <button className="btn btn-warning" onClick={() => {
                    this.props.getPauseService({ service_order__uuid: selectedService?.uuid }); // get pause service list
                    this.props.getPauseReason();// get pause reason
                    this.togglePauseService(true);
                  }}>Pause
                  </button>
                </div>
                */}
              </div>
            </div>
            <PausedList
              {...{
                ...this.props,
                ...this.state,
              }}
            />
            {/* {map(serviceOrder?.results, this.renderServiceDetails)} */}
          </div>
          <div className="work-orders-table">
            <PauseWarning
              {...{ ...this.props, ...this?.state }}
              setState={this.setState.bind(this)}
            />
            <div className="work-orders-toolbar">
              <div className="table-header sorting-btn-group flex ai-center">
                <h3 className="mb-0">Work Orders</h3>
                <div className="sorting flex ai-center no-bdr">
                  <button className={this.state?.viewType === "upcoming" ? "btn btn-upcoming" : "btn btn-history"} onClick={() => { this.upcomingWorkOrders() }}>Upcoming</button>
                  <button className={this.state?.viewType === "history" ? "btn btn-upcoming" : "btn btn-history"} onClick={() => { this.historyWorkOrders() }}>History</button>
                  <button className="btn btn-brand btn-bdr flex ai-center" onClick={() => { this.setState({ visible_edit_workOrder: true, workorder_uuid: '', transection_type: "Create" }) }}><img src={addGreenCircle} alt=""></img>Create Work Order</button>
                </div>
              </div>
              {!selectedService?.isPending && <div className="sorting sorting-fields flex no-bdr">
                <div className="fitem date-range-field mr-10">
                  <label>Date Range</label>
                  <RangePicker
                    format='MMM D, YYYY'
                    defaultValue={(!!this.state.startDate && !!this.state.endDate) ? [moment(this.state.startDate), moment(this.state.endDate)] : []}
                    onChange={(e) => { this.onDateRangeChange(e) }}
                  />
                </div>
                <div className="fitem service-order-field mr-10">
                  <label>Work Order</label>
                  {this.renderWorkOrderFilters()}
                </div>
                <div className="fitem service-order-field mr-10">
                  <label>Technician</label>
                  {this.renderTechnicianFilters()}
                </div>
                <div className="fitem service-order-field">
                  <label>Status</label>
                  {this.renderStatusFilters()}
                </div>
              </div>}
            </div>
            {!selectedService?.isPending && this.renderWorkOrders(true)}
            {selectedService?.isPending && <div style={{ textAlign: "center" }}>
              <p style={{ fontWeight: "bold" }}>
                {this.state?.viewType === "upcoming" ? "No Upcoming Work Orders" : "No History Work Orders"}
              </p>
              <span>
                Work orders will appear here when a service is active.
              </span>
            </div>}
            {/* {this.serviceHistoryTable()} */}
          </div>
        </div>
      </React.Fragment >
    );
  };

  // render views
  renderViews = () => {
    const { selectedView } = this.state;

    switch (selectedView) {
    case 0:
      return this.renderAllService();
    case 1:
      return this.renderSelectedService();
    default:
      return this.renderAllService();
    }
  };

  render() {
    const { loader, pauseServiceVisible, selectedService, viewHistory, currentHistory, requestRepair, editService, visible_edit_workOrder, workorder_uuid, transection_type, currentEditselectedService } = this.state;
    const { customerId, Service } = this.props;
    return (
      <div className="block-row p-0">
        <GlobalObserver
          {...{ ...this.props, ...this.state, setState: this.setState.bind(this) }}
        />
        <div className="container">
          {loader && <Loader />}
          {this.renderViews()}

          <AddDrawer
            {...{
              ...this.props,
              ...this.state,
            }}
            visible={pauseServiceVisible}
            setVisible={(x) => this.togglePauseService(x)}
          />
          {viewHistory && <ViewServiceHistory
            visible={viewHistory}
            currentHistory={currentHistory}
            closeDrawer={() => this.toggleViewHistory(false)}
            getServiceHistory={this.props.getServiceHistory} // api
            Service={this.props.Service} // reducers
          />}
          {requestRepair && <RequestRepair
            visible={requestRepair}
            service={selectedService}
            closeModal={() => this.toggleRequestRepair(false)}
            viewService={this.props.viewService}
            requestRepairService={this.props.requestRepairService}
          />}
          {editService && <EditServiceNew
            {
              ...{
                customer: this.props.customer,
                editService,
                selectedService,
                customerId,
                Service,
                goback: (e) => {
                  const { getServiceOrderById } = this.props;
                  this.toggleEditService(false);
                  Promise.allSettled([
                    getServiceOrderById(selectedService?.uuid)
                  ]).then(result => {
                    const isFulfilled = result.filter(x => x.status === "fulfilled");
                    if (isFulfilled?.length > 0) {
                      const { ServiceOrder } = this.props;
                      this.setState({
                        selectedService: ServiceOrder?.viewOrder
                      }, () => {
                        this.onViewService(ServiceOrder?.viewOrder);
                      })
                    }
                  });
                }
              }
            }
          />}
          {
            visible_edit_workOrder && <EditWorkOrderNew
              {
                ...{
                  visible_edit_workOrder,
                  transection_type,
                  workorder_uuid,
                  selectedService: selectedService !== null ? { uuid: selectedService?.uuid, commercial_order_line_item_type: selectedService?.commercial_order_line_item_type, header_bag_price: selectedService?.header_bag_price, roll_bag_price: selectedService?.roll_bag_price, service_address: selectedService?.service_address } : { uuid: currentEditselectedService?.service_order?.uuid, commercial_order_line_item_type: currentEditselectedService?.line_item_type, header_bag_price: currentEditselectedService?.header_bag_price, roll_bag_price: currentEditselectedService?.roll_bag_price, service_address: currentEditselectedService?.service_order?.service_address },
                  goback: (e) => {
                    this.toggleEditWorkOrder(false)
                    if (customerId) {
                      this.onFilterChange();
                    }
                  }
                }
              }
            />}
        </div>
      </div>
    );
  }
}

const setRecurring = (frequency) => {
  switch (frequency) {
  case 'twice_weekly':
    return 'Twice Weekly'
  case 'weekly':
    return 'Weekly'
  case 'bi_monthly':
    return 'Every Other Week'
  case 'monthly':
    return 'Monthly'
  case 'once':
    return 'One-Time'
  default:
    return ''
  }
}

function GlobalObserver(props) {
  useEffect(() => {
    window.axios = axios;
  }, [props])

  useEffect(() => {
    if(props.rerender) {
      props.rerender();
    }
  }, []);
  return null;
}

function ServiceList(props) {
  const {
    serviceOrder,
  } = { ...props?.props, ...props?.state };

  const {
    onViewService = () => {
      console.log('onViewService not defined');
    },
  } = props;

  const so = serviceOrder?.results;
  const active = so?.filter(x => !!x.is_active && !x.is_paused) || [];
  const inActive = so?.filter(x => !x.is_active) || [];
  const paused = so?.filter(x => !!x.is_paused && !!x.is_active) || [];
  // convert date time from utc to local time
  const UTCToLocal = (date) => {
    let stillUtc = moment.utc(date).toDate();
    return moment(stillUtc).local();
  }
  return (
    <div className="card-col service-order-card">
      <div className="card">
        <div className="card-body">
          {/* MAIN TITLE */}
          <div className="flex mb-20">
            <h3 className="mb-0">Service Orders</h3>
            {/* <a><img src={addGreenCircle} alt="" style={{ marginRight: '6px' }}></img> Create Service Order</a> */}
          </div>
          {/* ACTIVE SECTION */}
          {active?.length > 0 && <div className="service-status active-service">
            <div className="active_service_list color-252730">
              <div className="subs">
                <strong className="color-22232A service-status-head">Active</strong>
                {
                  active.map((x, i) => {
                    const serviceCoordsStr = x?.commercial_service_coordinates || "";
                    const serviceCoords = serviceCoordsStr?.substring(serviceCoordsStr?.indexOf("(") + 1, serviceCoordsStr.length - 1).split(',');
                    const type = x?.commercial_order_line_item_type || "product";
                    return (<React.Fragment key={i}>
                      <div className="flex justify-content-start position-relative">
                        <strong className="snum pointer">{x?.service_order_number}</strong>
                        <span className="color-1F1F25 opacity-5 fs-12">
                          {x?.community_nickname && x?.community_nickname != '' ? `${x?.community_nickname}-` : '' }{setRecurring(x.frequency)}
                        </span>
                      </div>
                      <div className="position-relative pointer" onClick={
                        () => { onViewService(x) }
                      }>
                        <span className="service-arrow">
                          <img src={chevronRight} alt="" />
                        </span>
                        <h5 className="sadd mb-4">{(!isEmpty(x?.service_address?.formatted_address) && !isEmpty(x?.service_address?.address)) ? `${x?.service_address?.formatted_address}` : '-'}</h5>
                        {
                          type === "service" ? <div>
                            {
                              serviceCoords.length > 0 && serviceCoords.map((coord, i) => {
                                return <span key={i} style={{
                                  display: 'block',
                                }} className="latitude pl-20 opacity-5 fs-11">{coord}</span>
                              })
                            }
                          </div> :
                           !isEmpty(x?.service_address?.geo_location) ? <span className="latitude pl-20 opacity-5 fs-11">{`${x?.service_address?.geo_location?.latitude}, ${x?.service_address?.geo_location?.longitude}`}</span> : <></>
                        }
                        {x?.last_increase_effective_date?
                          <div>
                            <strong class="altude pl-20 fs-11" style={{marginBottom: "auto", color: "#407977"}}>Price Increase Date: {x?.last_increase_effective_date?UTCToLocal(x?.last_increase_effective_date).format('MMM DD, YYYY'):"-"}</strong>
                            <strong class="altude pl-20 fs-11" style={{marginBottom: "auto", color: "#407977"}}>Price Increase: {x?.last_increase_amount?x?.last_increase_amount:"-"}  {x?.last_increase_status? x?.last_increase_status === "Completed"?"(Applied)":"(Yet to be applied)" : "-"}</strong>                        
                          </div>
                      :
                        <></>
                      }
                      </div>
                      {(active?.length - 1) !== i && <hr />}
                    </React.Fragment>)
                  })
                }
              </div>
            </div>
          </div>}
          {/* END ACTIVE SECTION */}
          {/* PAUSED SECTION */}
          {paused?.length > 0 && <div className="service-status paused-service">
            <div className="active_service_list lh-21 color-252730">
              <div className="subs">
                <strong className="color-22232A service-status-head">Paused</strong>
                {
                  paused.map((x, i) => {
                    const serviceCoordsStr = x?.commercial_service_coordinates || "";
                    const serviceCoords = serviceCoordsStr?.substring(serviceCoordsStr?.indexOf("(") + 1, serviceCoordsStr.length - 1).split(',');
                    const type = x?.commercial_order_line_item_type || "product";
                    return (<React.Fragment key={i}>
                      <div className="flex justify-content-start position-relative">
                        <strong className="snum pointer">{x?.service_order_number}</strong>
                        <span className="color-1F1F25 opacity-5 fs-12">{setRecurring(x.frequency)}</span>
                      </div>
                      <div className="position-relative pointer" onClick={
                        () => { onViewService(x) }
                      }>
                        <span className="service-arrow">
                          <img src={chevronRight} alt="" />
                        </span>
                        <h5 className="sadd mb-4">{(!isEmpty(x?.service_address?.formatted_address) && !isEmpty(x?.service_address?.address)) ? `${x?.service_address?.formatted_address}` : '-'}</h5>
                        {
                          type === "service" ? <div>
                            {
                              serviceCoords.length > 0 && serviceCoords.map((coord, i) => {
                                return <span key={i} style={{
                                  display: 'block',
                                }} className="latitude pl-20 opacity-5 fs-11">{coord}</span>
                              })
                            }
                          </div> :
                            <span className="latitude pl-20 opacity-5 fs-11">{!isEmpty(x?.service_address?.geo_location) ? `${x?.service_address?.geo_location?.latitude}, ${x?.service_address?.geo_location?.longitude}` : ``}</span>
                        }
                      </div>
                      {(paused?.length - 1) !== i && <hr />}
                    </React.Fragment>)
                  })
                }
              </div>
            </div>
          </div>}
          {/* END PAUSED SECTION */}
          {/* INACTIVE SECTION */}
          {inActive?.length > 0 && <div className="service-status inactive-service">
            <div className="active_service_list lh-21 color-252730">
              <div className="subs">
                <strong className="color-22232A service-status-head">Inactive</strong>
                {
                  inActive.map((x, i) => {
                    const serviceCoordsStr = x?.commercial_service_coordinates || "";
                    const serviceCoords = serviceCoordsStr?.substring(serviceCoordsStr?.indexOf("(") + 1, serviceCoordsStr.length - 1).split(',');
                    const type = x?.commercial_order_line_item_type || "product";
                    return (<React.Fragment key={i}>
                      <div className="flex justify-content-start position-relative">
                        <strong className="snum pointer">{x?.service_order_number}</strong>
                        <span className="color-1F1F25 opacity-5 fs-12">{setRecurring(x.frequency)}</span>
                      </div>
                      <div className="position-relative pointer" onClick={
                        () => { onViewService(x) }
                      }>
                        <span className="service-arrow">
                          <img src={chevronRight} alt="" />
                        </span>
                        <h5 className="sadd mb-4">{(!isEmpty(x?.service_address?.formatted_address) && !isEmpty(x?.service_address?.address)) ? `${x?.service_address?.formatted_address}` : '-'}</h5>
                        {
                          type === "service" ? <div>
                            {
                              serviceCoords.length > 0 && serviceCoords.map((coord, i) => {
                                return <span key={i} style={{
                                  display: 'block',
                                }} className="latitude pl-20 opacity-5 fs-11">{coord}</span>
                              })
                            }
                          </div> :
                            <span className="latitude pl-20 opacity-5 fs-11">{!isEmpty(x?.service_address?.geo_location) ? `${x?.service_address?.geo_location?.latitude}, ${x?.service_address?.geo_location?.longitude}` : ``}</span>
                        }
                      </div>
                      {(inActive?.length - 1) !== i && <hr />}
                    </React.Fragment>)
                  })
                }
              </div>
            </div>
          </div>}
        </div>
      </div>
    </div>
  )
}

function Observer(props) {
  const {
    state,
    setState = () => { },
  } = props;

  const fetchPausedServices = () => {
    const uuid = state?.currentSelectedService?.uuid || state.selectedService.uuid;
    axios.get(`/service-pause`, {
      params: {
        service_order__uuid: uuid,
      },
    }).then(res => {
      setState({
        pausedServices: res?.data,
      });
    });
  }

  const fetchReasons = () => {
    axios.get(`/service-pause-reason/`).then(res => {
      setState({
        reasons: res?.data?.results,
      });
    }).catch(err => {
      console.log(err);
    });
  }

  useEffect(() => {
    setState({
      fetchPausedServices,
      fetchReasons,
    });
  }, [state.pausedServices]);

  useEffect(() => {
    if (Object.keys(state?.currentSelectedService || state?.selectedService || {}).length > 0) {
      fetchPausedServices();
    }
    fetchReasons();
  }, [state?.selectedService, state?.currentSelectedService])

  return <></>;
}

function PausedList(props) {

  const { pausedServices } = props;

  const [isHistory, setIsHistory] = useState(false);

  const [visible, setVisible] = useState(false);

  const [currentSelection, setCurrentSelection] = useState();

  const [selectedNode, setSelectedNode] = useState();

  const [drawerVisible, setDrawerVisible] = useState(false)

  const onClose = () => {
    setVisible(false)
  }

  const endPause = (uuid) => {
    axios.delete(`/service-pause/${uuid}`)
      .then(res => {
        message.success("Paused Service Deleted Successfully", 10)
        props.rerender();
        props?.fetchPausedServices && props.fetchPausedServices();
        setVisible(false)
      })
      .catch(err => {
        message.error("Error in deleting a pause", 10)
        console.log("err", err)
      })
  }

  return (
    <div style={{ marginTop: 3 }}>
      <div className="card">
        <div style={{
          padding: "1rem",
          display: "flex",
          justifyContent: "space-between",
          verticalAlign: "middle",
        }}>
          <h3
            style={{
              marginBottom: "auto",
              marginTop: "auto",
            }}
          >Pauses</h3>
          <div className="sorting-btn-group">
            <button className={`btn ${isHistory ? "btn-history" : "btn-upcoming"}`}
              onClick={() => setIsHistory(false)}
            >Upcoming</button>
            <button className={`btn ${!isHistory ? "btn-history" : "btn-upcoming"}`}
              onClick={() => setIsHistory(true)}
            >History</button>
          </div>
        </div>
        <hr />
        <div className="card-body" style={{
          height: "320px",
          overflowY: "auto",
        }}>
          {
            ((isHistory && pausedServices?.history?.length > 0) || (!isHistory && pausedServices?.upcoming?.length > 0)) ? (isHistory ? pausedServices?.history : pausedServices?.upcoming)?.map((node, index) => {
              return (
                <React.Fragment key={index}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    key={index}
                  >
                    <div style={{
                      display: "flex",
                      flexDirection: "column",
                    }}>
                      <p style={{
                        fontWeight: "bold",
                        color: "#407977",
                        marginBottom: "0",
                      }}>
                        {/* date in the format: Mmmm DD, YYYY */}
                        {moment(node?.pause_from).format("MMM DD, YYYY")}
                        {
                          node?.pause_to ?
                            <>
                              {
                                " to " + moment(node.pause_to).format("MMM DD, YYYY")
                              }
                            </>
                            :
                            <>
                              {" to Indefinite"}
                            </>
                        }
                      </p>
                      <p
                        style={{
                          marginBottom: 3,
                        }}
                      >
                        {
                          node?.reason?.reason
                        }
                      </p>
                    </div>
                    <div style={{
                      display: "flex",
                    }}>
                      {
                        node?.status?.toUpperCase() !== "HISTORY" && (
                          <div style={{
                            marginTop: "0.4rem",
                          }}>
                            <span className={`status ${node?.status?.includes("in_progress") ? "info-status" : "gray-status"}`}>{
                              node?.status?.replace(/_/g, ' ')?.toUpperCase()
                            }</span>
                          </div>
                        )
                      }
                      <div className="dropdown" style={{
                        marginTop: "0.7rem",
                      }}>
                        <div className="position-relative pause-dropdown">
                          {
                            !isHistory && <>
                              <button className="dots-button"><span></span><span></span><span></span></button>
                              <ul className="pause-dropdownmenu">
                                <li><a
                                  onClick={() => {
                                    setSelectedNode({ ...node });
                                    setDrawerVisible(true);
                                  }}
                                >Edit Pause</a></li>
                                <li><a
                                  onClick={() => {
                                    setVisible(true);
                                    setCurrentSelection(node);
                                  }}>Delete Pause</a></li>
                              </ul>
                            </>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </React.Fragment>
              )
            }) : <>
              {isHistory ? <p className="text-center">No pauses in past!</p> : <p className="text-center">No upcoming pauses!</p>}
            </>
          }
        </div>
      </div>
      <Modal
        title="Delete Pause?"
        visible={visible}
        className="sm-modal"
        onCancel={() => onClose()}
        footer={[
          <button key="cancel" className="btn btn-success btn-bdr"
            onClick={() => onClose()}
          >Cancel</button>,
          <button key="save" className="btn btn-warning"
            onClick={() => endPause(currentSelection?.uuid)}
          >Delete</button>
        ]}
      >
        <span>
          Are you sure you would like to delete this pause? Once deleted, it will be removed from the pause panel.
        </span>
      </Modal>
      <EditDrawer
        {...{
          ...props,
        }}
        selectedNode={selectedNode}
        visible={drawerVisible}
        setVisible={setDrawerVisible}
      />
    </div>
  )
}

function PauseWarning(props) {
  const {
    currentSelectedService,
    serviceOrder,
  } = props;

  const pause_obj = serviceOrder?.results?.find(node => node?.uuid === currentSelectedService?.uuid)?.pause_obj;

  const [visible, setVisible] = useState(false)

  const [drawerVisible, setDrawerVisible] = useState(false)

  if (!pause_obj) {
    return <></>
  }

  const onClose = () => {
    setVisible(false)
  }

  const endPause = () => {
    const { customerId } = props;
    axios.patch(`/service-pause/${pause_obj?.uuid}/`, {
      "is_end_pause": true,
    })
      .then(res => {
        message.success("Service Resumed Successfully", 5)
        setTimeout(() => {
          props.rerender();
          props?.fetchPausedServices && props.fetchPausedServices();
          props.getCommercialWorkOrderList && props.getCommercialWorkOrderList({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
        }, 2000)
        setVisible(false)
      })
      .catch(err => {
        message.error("Error in resuming service!", 10)
        console.log("err", err)
      })
  }

  return (
    <div className="order-alert-warning">
      <div>
        <p>This service order is currently  paused and may affect upcoming work orders:</p>
        <div className="alert-dateblock">
          <span>{moment(pause_obj?.pause_from).format("MMMM DD, YYYY")} to {pause_obj?.pause_to ? moment(pause_obj?.pause_to).format("MMMM DD, YYYY") : "Indefinite"}</span>
          {pause_obj?.reason?.reason}
        </div>
      </div>
      <div className="flex ai-center alert-cation-btn">
        <a role="button"
          onClick={() => setVisible(true)}
        >
          <img src="/static/media/pauseplay-icon.bbc96dcc.svg" alt="" />End Pause</a>
        <a role="button"
          onClick={() => setDrawerVisible(true)}
        >
          <img src="/static/media/edit-pencil-green.0d647a03.svg" alt="" />Edit Pause</a>
      </div>
      <EditDrawer
        {...{
          ...props,
        }}
        selectedNode={pause_obj}
        isInProgress={true}
        visible={drawerVisible}
        setVisible={setDrawerVisible}
      />
      <Modal
        title="Resume Service Order"
        visible={visible}
        className="sm-modal"
        onCancel={() => onClose()}
        footer={[
          <button key="cancel" className="btn btn-success btn-bdr"
            onClick={() => onClose()}
          >Cancel</button>,
          <button key="save" className="btn btn-warning"
            onClick={() => endPause()}
          >Resume Service Order</button>
        ]}
      >
        <span>
          This serive order is currently on a pause:
        </span>
        <div className="alert-dateblock">
          <span style={{
            fontWeight: "bold",
            color: "#242424",
          }}>{moment(pause_obj?.pause_from).format("MMMM DD, YYYY")} to {pause_obj?.pause_to ? moment(pause_obj?.pause_to).format("MMMM DD, YYYY") : "Indefinite"}</span>
          {pause_obj?.reason?.reason}
        </div>
      </Modal>
    </div>
  )
}

// a react functional component with antd side drawer
function EditDrawer(props) {

  const {
    selectedNode,
    visible,
    setVisible,
  } = props;

  const reasons = props?.reasons || [];

  const [form, setForm] = useState({
    reason: "",
    pause_from: "",
    pause_to: "",
    pause_until_manually_resumed: false,
  });

  const [currentNodeUUID, setCurrentNodeUUID] = useState()
  const [errors, setErrors] = useState({});
  const [isInProgress, setIsInProgress] = useState(props?.isInProgress || false);

  useLayoutEffect(() => {

    if (selectedNode) {
      if (selectedNode?.status === "in_progress" || selectedNode?.status?.toLowerCase() === "in progress") {
        setIsInProgress(true);
      }
    }

    if (selectedNode && selectedNode?.uuid !== currentNodeUUID) {
      setForm({
        ...form,
        pause_from: moment(selectedNode?.pause_from),
        pause_to: moment(selectedNode?.pause_to),
        pause_until_manually_resumed: selectedNode?.pause_to ? false : true,
        reason: selectedNode?.reason?.uuid,
      })
      setCurrentNodeUUID(selectedNode?.uuid)
    }
  }, [selectedNode])

  const onClose = () => {
    setVisible(false)
    setCurrentNodeUUID();
  }

  const updateForm = (key, value) => {
    setErrors({
      ...errors,
      [key]: undefined,
    })

    setForm({
      ...form,
      ...key === "pause_until_manually_resumed" ? { pause_to: null } : {},
      ...(key === "pause_from" && moment(value).diff(moment(form.pause_to)) >= 0) ? { pause_to: null } : {},
      [key]: value,
    })
  }

  const schema = yup.object().shape({
    reason: yup.string().required("Reason is required"),
    pause_from: yup.string().required("Select a Pause Start Date"),
    // pause_to required if pause_until_manually_resumed is false
    pause_to: yup.string().when("pause_until_manually_resumed", {
      is: false,
      then: yup.string().required("Select a Pause End Date"),
    }).nullable(),
  });

  const validateFormWithoutSettingErrors = () => {
    return schema.isValid(form);
  }

  const validateForm = () => {
    // validate the form
    try {
      schema.validateSync(form, {
        abortEarly: false,
      });
      return true;
    } catch (err) {
      if (err?.inner) {
        const localErrors = {};
        err.inner.forEach(e => {
          localErrors[e.path] = e.message;
        });
        setErrors({
          ...errors,
          ...localErrors,
        });
      }
      return false;
    }
  }

  const onSubmit = () => {
    const { customerId } = props;
    axios.patch(`/service-pause/${selectedNode?.uuid}/`, {
      service_order_uuid: selectedNode?.service_order_uuid,
      service_reason_uuid: form.reason,
      pause_from: moment(form.pause_from).format("YYYY-MM-DD"),
      pause_to: moment(form.pause_to).format("YYYY-MM-DD"),
      suspend_until_manual: form.pause_until_manually_resumed,
      understand_pause_func: false,
      is_end_pause: false,
    })
      .then(res => {
        message.success("Service pause updated successfully!", 10);
        props.getCommercialWorkOrderList({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
        props.rerender();
        props?.fetchPausedServices && props.fetchPausedServices();
        setVisible(false);
      })
      .catch(err => {
        message.error("Error in updating pause!", 10)
        console.log("err", err)
      })
  }

  const isValid = validateFormWithoutSettingErrors();

  return (
    <Drawer
      placement="right"
      closable={false}
      // onClose={onClose}
      visible={visible}
      width={525}
      className="drawer-wrapper create_ticket_drawer"
    >
      <div style={{
        display: "flex",
        // justifyContent: "space-between",
        padding: "1rem",
        flexDirection: "column",
      }}
      className="edit-service-drawer  rdrawer"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h2>
            Edit Pause
          </h2>
          <CloseOutlined
            style={{
              marginTop: "0.5rem",
            }}
            onClick={() => {
              onClose();
            }}
          />
        </div>
        <div>
          <span>
            Pause Start Date <span
              style={{
                color: "#ff0000",
              }}
            >*</span>
            <DatePicker
              format="MMM DD, YYYY"
              disabled={isInProgress}
              disabledDate={(current) => { return current && current < moment().add(-1, 'days').endOf('day'); }}
              onChange={(date, dateString) => {
                if (!date) {
                  updateForm("pause_from", "")
                  return;
                }
                // updateForm("pause_from", moment(date).format("YYYY-MM-DD"))
                updateForm("pause_from", date)
              }}
              // value={form.pause_from ? moment(form.pause_from) : null}
              value={form.pause_from}
            />
            {errors?.pause_from && <span style={{ color: "#f00", display: "block" }}>{errors?.pause_from}</span>}
            <span>
              <a style={{
                fontWeight: "bold",
                marginRight: "0.5rem",
              }}
              onClick={() => {
                if (isInProgress) {
                  return;
                }
                updateForm("pause_from", moment().format("YYYY-MM-DD"))
              }}
              >Today</a>
              <a style={{
                fontWeight: "bold",
              }}
              onClick={() => {
                if (isInProgress) {
                  return;
                }
                updateForm("pause_from", moment().add(1, 'days').format("YYYY-MM-DD"))
              }}
              >Tomorrow</a>
            </span>
          </span>
        </div>
        <div style={{
          marginTop: "1rem",
        }}>
          <span>
            Pause End Date <span
              style={{
                color: "#ff0000",
              }}
            >*</span>
            <DatePicker
              format="MMM DD, YYYY"
              disabled={form.pause_until_manually_resumed}
              disabledDate={(current) => { return current && (current <= moment(form.pause_from).endOf('day') || current < moment().endOf('day')); }}
              onChange={(date, dateString) => {
                if (!date) {
                  updateForm("pause_to", "")
                  return;
                }
                // updateForm("pause_to", moment(date).format("YYYY-MM-DD"))
                updateForm("pause_to", date)
              }}
              value={form.pause_to}
              // value={form.pause_to ? moment(form.pause_to) : null}
            />
            {errors?.pause_to && <span style={{ color: "#f00", display: "block" }}>{errors?.pause_to}</span>}
            <span>
              <div className="fitem-check">
                <span
                  onClick={() => {
                    updateForm("pause_until_manually_resumed", !form.pause_until_manually_resumed);
                  }}
                >
                  <input
                    type="checkbox"
                    className="fitem-ck-input"
                    checked={form.pause_until_manually_resumed}
                    name="manual_pause"
                    onChange={() => { }}
                  />
                  <label htmlFor={`manual_pause`} className="fitem-ck-txt">{`Pause until manually resumed`}</label>
                </span>
              </div>
            </span>
          </span>
        </div>
        <div
          style={{
            marginTop: "1rem",
          }}
        >
          <span>
            Reason for Pause <span
              style={{
                color: "#ff0000",
              }}
            >*</span>
          </span>
          <Select
            showArrow
            showSearch
            placeholder={"Choose a reason for pausing this service"}
            virtual={false}
            style={{ width: "100%" }}
            value={form.reason || null}
            onChange={(value) => {
              updateForm("reason", value)
            }}
          >
            {map(reasons, (x) => <Option value={x.uuid} key={x.uuid}>{x.reason}</Option>)}
          </Select>
          {errors?.reason && <span style={{ color: "#f00", display: "block" }}>{errors?.reason}</span>}
        </div>
        <div className="footer">
          <button className={`btn btn-bdr`} onClick={() => {
            onClose();
          }}>Cancel</button>
          <button
            // type="submit"
            className={`btn btn-warning`}
            disabled={
              !isValid
            }
            onClick={() => {
              validateForm() && onSubmit();
            }}>
            Save Pause
          </button>
        </div>
      </div>
    </Drawer>
  )
}

function AddDrawer(props) {
  const {
    visible,
    setVisible,
    selectedService
  } = props;

  const reasons = props?.reasons || [];

  const [form, setForm] = useState({
    reason: "",
    pause_from: "",
    pause_to: "",
    pause_until_manually_resumed: false,
  });

  useEffect(() => {
    setForm({
      reason: "",
      pause_from: "",
      pause_to: "",
      pause_until_manually_resumed: false,
    })
  }, [visible])

  const [errors, setErrors] = useState({});

  const onClose = () => {
    setVisible(false)
  }

  const updateForm = (key, value) => {

    setErrors({
      ...errors,
      [key]: undefined,
    })

    setForm({
      ...form,
      ...key === "pause_until_manually_resumed" ? { pause_to: null } : {},
      ...(key === "pause_from" && moment(value).diff(moment(form.pause_to)) >= 0) ? { pause_to: null } : {},
      [key]: value,
    })
  }

  const schema = yup.object().shape({
    reason: yup.string().required("Reason is required"),
    pause_from: yup.string().required("Select a Pause End Date"),
    // pause_to required if pause_until_manually_resumed is false
    pause_to: yup.string().when("pause_until_manually_resumed", {
      is: false,
      then: yup.string().required("Select a Pause Start Date"),
    }).nullable(),
  });

  const validateFormWithoutSettingErrors = () => {
    return schema.isValid(form);
  }

  const validateForm = () => {
    // validate the form
    try {
      schema.validateSync(form, {
        abortEarly: false,
      });
      return true;
    } catch (err) {
      if (err?.inner) {
        const localErrors = {};
        err.inner.forEach(e => {
          localErrors[e.path] = e.message;
        });
        setErrors({
          ...errors,
          ...localErrors,
        });
      }
      return false;
    }
  }

  const onSubmit = () => {
    const { customerId } = props;
    axios.post(`/service-pause/`, {
      service_order_uuid: selectedService?.uuid,
      service_reason_uuid: form.reason,
      pause_from: form.pause_from,
      pause_to: form.pause_to,
      suspend_until_manual: form.pause_until_manually_resumed,
      understand_pause_func: false,
    })
      .then(res => {
        message.success("Service paused successfully!", 10);
        props.getCommercialWorkOrderList({service_order__user__uuid: customerId, scheduled_time__gte: moment(new Date()).format("YYYY-MM-DD hh:mm:ss"), ordering: 'scheduled_time'});
        props.rerender();
        props?.fetchPausedServices && props.fetchPausedServices();
        setVisible(false)
      })
      .catch(err => {
        message.error((!!err?.response?.data && err?.response?.data?.join(',')) || "Error in pausing service!", 10)
        console.log("err", err?.response?.data?.[0])
      })
  }

  const isValid = validateFormWithoutSettingErrors();

  return (
    <Drawer
      placement="right"
      closable={false}
      // onClose={onClose}
      visible={visible}
      width={525}
      className="drawer-wrapper create_ticket_drawer"
    >
      <div style={{
        display: "flex",
        // justifyContent: "space-between",
        padding: "1rem",
        flexDirection: "column",
      }}
      className="edit-service-drawer  rdrawer"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h2>
            Add Pause
          </h2>
          <CloseOutlined
            style={{
              marginTop: "0.5rem",
            }}
            onClick={() => {
              onClose();
            }}
          />
        </div>
        <div>
          <span>
            Pause Start Date <span
              style={{
                color: "#ff0000",
              }}
            >*</span>
            <DatePicker
              format="MMM DD, YYYY"
              disabledDate={(current) => { return current && current < moment().add(-1, 'days').endOf('day'); }}
              onChange={(date, dateString) => {
                if (!date) {
                  updateForm("pause_from", "")
                  return;
                }
                updateForm("pause_from", moment(date).format("YYYY-MM-DD"))
              }}
              value={form.pause_from ? moment(form.pause_from) : null}
            />
            {errors?.pause_from && <span style={{ color: "#f00", display: "block" }}>{errors?.pause_from}</span>}
            <span>
              <a style={{
                fontWeight: "bold",
                marginRight: "0.5rem",
              }}
              onClick={() => {
                updateForm("pause_from", moment().format("YYYY-MM-DD"))
              }}
              >Today</a>
              <a style={{
                fontWeight: "bold",
              }}
              onClick={() => {
                updateForm("pause_from", moment().add(1, 'days').format("YYYY-MM-DD"))
              }}
              >Tomorrow</a>
            </span>
          </span>
        </div>
        <div style={{
          marginTop: "1rem",
        }}>
          <span>
            Pause End Date <span
              style={{
                color: "#ff0000",
              }}
            >*</span>
            <DatePicker
              format="MMM DD, YYYY"
              disabled={form.pause_until_manually_resumed}
              disabledDate={(current) => { return current && (current <= moment(form.pause_from).endOf('day') || current < moment().endOf('day')); }}
              onChange={(date, dateString) => {
                if (!date) {
                  updateForm("pause_to", "")
                  return;
                }
                updateForm("pause_to", moment(date).format("YYYY-MM-DD"))
              }}
              value={form.pause_to ? moment(form.pause_to) : null}
            />
            {errors?.pause_to && <span style={{ color: "#f00", display: "block" }}>{errors?.pause_to}</span>}
            <span>
              <div className="fitem-check">
                <span
                  onClick={() => {
                    updateForm("pause_until_manually_resumed", !form.pause_until_manually_resumed);
                  }}
                >
                  <input
                    type="checkbox"
                    className="fitem-ck-input"
                    checked={form.pause_until_manually_resumed}
                    name="manual_pause"
                    onChange={() => { }}
                  />
                  <label htmlFor={`manual_pause`} className="fitem-ck-txt">{`Pause until manually resumed`}</label>
                </span>
              </div>
            </span>
          </span>
        </div>
        <div
          style={{
            marginTop: "1rem",
          }}
        >
          <span>
            Reason for Pause <span
              style={{ color: "#ff0000"}}
            >*</span>
          </span>
          <Select
            showArrow
            showSearch
            placeholder={"Choose a reason for pausing this service"}
            virtual={false}
            style={{ width: "100%" }}
            value={form.reason || null}
            onChange={(value) => {
              updateForm("reason", value)
            }}
          >
            {map(reasons, (x) => <Option value={x.uuid} key={x.uuid}>{x.reason}</Option>)}
          </Select>
          {errors?.reason && <span style={{ color: "#f00", display: "block" }}>{errors?.reason}</span>}
        </div>
        <div className="footer">
          <button className={`btn btn-bdr`} onClick={() => {
            onClose();
          }}>Cancel</button>
          <button
            // type="submit"
            className={`btn btn-warning`}
            disabled={
              !isValid
            }
            onClick={() => {
              validateForm() && onSubmit();
            }}>
            Save Pause
          </button>
        </div>
      </div>
    </Drawer>
  )
}

export default Services;